import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
  SimpleChanges,
 
  Inject,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { SignaturePad } from "angular2-signaturepad";
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { CommonHttpService } from "src/app/common.service";
import { ConfigurationService } from "src/app/configuration.service";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { functionpermission } from "../../client-parent/client-parent.model";
import { EmployeeAgreementTemplateService } from "../../employee-agreement-template/employee-agreement-template.service";
import { EmployeeService } from "../../employee/employee.service";
import { employeeOnboardBO, PageNavigateBo, SendToClientBO, SendToEmployeeBO } from "../employee-agreement.model";
import { EmployeeAgreementService } from "../employee-agreement.service";
import {
  BackgroundStudyAuthorizationBO,
  DswBackgroundStudyInfoFormBO,
  EmployeeAgreementAndDirectDepositBO,
  EmployeeAgreementBO,
  EmployeeApplicationCoverBO,
  EmployeesWithholdingCertificateBO,
  EmploymentEligibilityVerificationBO,
  GetListBO,
  IndividualDirectSupportWorkerEnrollmentApplicationBO,
  IndividualSupportWorkerProviderAgreementBO,
  PayNoticeBO,
  PayNoticePayrateDetailBO,
  RelationshipDisclosureBO,
  RelationshipDisclosureTaxDetailBO,
  SubmitEmployeeAggremntBo,
  W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO,
  W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO,
} from "./document.model";
import { AccountNumberShowBO } from "../../employee/employee-payroll/employee-payroll.model";
import { EmployeePayrollService } from "../../employee/employee-payroll/employee-payroll.service";
// import { employeeTemplate } from "../agreement-template/agreement-template.model";

@Component({
  selector: "app-document",
  templateUrl: "./document.component.html",
  styleUrls: ["./document.component.scss"],
})
export class DocumentComponent implements OnInit {
  agreementBo: EmployeeAgreementBO = new EmployeeAgreementBO();

  backgroundBo: BackgroundStudyAuthorizationBO =
    new BackgroundStudyAuthorizationBO();
  employeeAgreementBo: EmployeeAgreementAndDirectDepositBO =
    new EmployeeAgreementAndDirectDepositBO();
  employeeApplicationBo: EmployeeApplicationCoverBO =
    new EmployeeApplicationCoverBO();
  employeesWithholdingBo: EmployeesWithholdingCertificateBO =
    new EmployeesWithholdingCertificateBO();
  employmentEligibilityBo: EmploymentEligibilityVerificationBO =
    new EmploymentEligibilityVerificationBO();
  individualDirectSupportBo: IndividualDirectSupportWorkerEnrollmentApplicationBO =
    new IndividualDirectSupportWorkerEnrollmentApplicationBO();
  individualSupportWorkerBo: IndividualSupportWorkerProviderAgreementBO =
    new IndividualSupportWorkerProviderAgreementBO();
  payNoticeBo: PayNoticeBO = new PayNoticeBO();
  relationshipBo: RelationshipDisclosureBO = new RelationshipDisclosureBO();
  w4MinnesotaWithholdingBo: W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO =
    new W4MinnesotaWithholdingAllowanceOrExemptionCertificateBO();
  w4MNInstructionsBo: W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO =
    new W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsBO();

  DSwstudyBo: DswBackgroundStudyInfoFormBO[] = [];

  relationdisclosureBo: RelationshipDisclosureTaxDetailBO[] = [];
  PayNoticePayrateDetailBo:PayNoticePayrateDetailBO[]=[];

  DSwstudyBolistarray = {
    bsgNumber: null,
    applicationNumber: null,
    facilityId: null,
    isadd: true,
    id:"00000000-0000-0000-0000-000000000000"
  };
  section1radio:any
  isComplete = false;
  getpayratelist = new GetListBO();
  payratelist: any;
  relationshiplist: any;
  prepopulatevalue: any;
  prepopulateClientvalue: any;
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() PageViewCreateOrEdit = new PageNavigateBo();
  @Output() newItemEvent = new EventEmitter<PageNavigateBo>();
  PageNavigate: PageNavigateBo = new PageNavigateBo();
  @Input() emitemployeeBO = new employeeOnboardBO();
  /////model of agreement//////
  Employeesign: string = "";
  Gurdiansign: string = "";
  Gsign: string = "";
  PreviousName: any = [];
  payRateList: any = [];
  isUpdate: boolean = false;

  drawCompleteEmployeesign() {
    this.Employeesign = this.EnrollmentsignaturePad.toDataURL();
    this.applicantSignatureName = this.Employeesign;
  }
  applicantSignatureName: string = "";
  ClearEmployeeSignature() {
    this.EnrollmentsignaturePad.clear();
    this.Employeesign = "";
  }
  drawCompleteGurdiansign() {
    this.Gurdiansign = this.GurdiansignaturePad.toDataURL();
  }
  drawGurdiansign() {
    this.Gsign = this.GurdianPad.toDataURL();
  }
  ClearGurdianSignature1() {
    this.GurdianPad.clear();
    this.Gsign = "";
  }
  ClearGurdianSignature() {
    this.GurdiansignaturePad.clear();
    this.Gurdiansign = "";
  }
  applicantsign = "";
  drawCompleteapplicantsign() {
    this.applicantsign = this.ApplicantsignaturePad.toDataURL();
  }
  clearApplicantsign() {
    this.ApplicantsignaturePad.clear();
    this.applicantsign = "";
  }
  legalsign = "";
  drawCompletelegalsign() {
    this.legalsign = this.LegalsignaturePad.toDataURL();
  }
  clearLegalsign() {
    this.LegalsignaturePad.clear();
    this.legalsign = "";
  }

  yes_or_no_lst: [];
  // get_yes_or_noLSt() {
  //   let params = new URLSearchParams();
  //   params.append("Code", "YESORNO");
  //   this.employeeservice.getcommon(params).subscribe((data: any) => {
  //     this.yes_or_no_lst = data;
  //   });
  // }

  relation_lst = [];
  // get_relation_lst() {
  //   let params = new URLSearchParams();
  //   params.append("Code", "RELATIONLIST");
  //   this.employeeservice.getcommon(params).subscribe((data: any) => {
  //     this.relation_lst = data;
  //   });
  // }
  EducationColumn: boolean = false;
  doctype: string = "";
  changedModel = [
    {
      name: "Asian",
    },
    {
      name: "Pacific Islander",
    },
    {
      name: "African American",
    },
    {
      name: "Native American",
    },
    {
      name: "White",
    },
    {
      name: "Hispanic/Latino",
    },
    {
      name: "Unknown/Other",
    },
    {
      name: "Two or More Races",
    },
  ];

  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  @ViewChild("EnrollmentsignaturePad") EnrollmentsignaturePad: SignaturePad;
  @ViewChild("GurdiansignaturePad") GurdiansignaturePad: SignaturePad;
  @ViewChild("GurdianPad") GurdianPad: SignaturePad;
  @ViewChild("ApplicantsignaturePad") ApplicantsignaturePad: SignaturePad;
  @ViewChild("LegalsignaturePad") LegalsignaturePad: SignaturePad;
  @ViewChild("rollPad") rollPad: SignaturePad;
  @ViewChild("rollPad1") rollPad1: SignaturePad;
  @ViewChild("rollPad2") rollPad2: SignaturePad;
  @ViewChild("rollPad3") rollPad3: SignaturePad;
  @ViewChild("rollPad4") rollPad4: SignaturePad;
  @ViewChild("appsignpad") appsignpad: SignaturePad;
  @ViewChild("parentsignpad") parentsignpad: SignaturePad;
  @ViewChild("authsignpad") authsignpad: SignaturePad;
  @ViewChild("EnPad") EnPad: SignaturePad;
  @ViewChild("Pad") Pad: SignaturePad;
  @ViewChild("EnrollPad_2") EnrollPad_2: SignaturePad;
  @ViewChild("EmpSignPad") EmpSignPad: SignaturePad;
  @ViewChild("EnrollPad") EnrollPad: SignaturePad;
  @ViewChild("EnrollPad_EMP") EnrollPad_EMP: SignaturePad;
  @ViewChild("EnrollPad_APP") EnrollPad_APP: SignaturePad;
  isSaveorUpdateBoolean:boolean=false;
  drawCompleteEmpsign() {
    this.Employeesign = this.EmpSignPad.toDataURL();
  }
  ClearEmployee_sign() {
    this.EnrollPad_2.clear();
    this.employeesign = "";
  }
  ClearEmployee_sign1() {
    this.EnrollPad_EMP.clear();
    this.employeesign2 = "";
  }
  ClearApplicant_sign() {
    this.EnrollPad_APP.clear();
    this.clientsign0 = "";
  }
  drawsign() {
    this.Gurdiansign = this.EnrollPad.toDataURL();
  }
  employeesign2: any;
  drawsign_employer() {
    this.employeesign2 = this.EnrollPad_EMP.toDataURL();
  }
  employeesign3: any;
  drawsign_employer_2() {
    this.employeesign3 = this.EnrollPad_2.toDataURL();
  }

  clearemployyesing3() {
    this.EnrollPad_2.clear();
    this.employeesign3 = "";
  }
  clientsign0: any;
  drawsign_applicant() {
    this.clientsign0 = this.EnrollPad_APP.toDataURL();
  }

  ClearEmployeeSignature1() {
    this.EmpSignPad.clear();
    this.Employeesign = "";
  }
  ClearEmployeeSignature2() {
    this.EnrollPad.clear();
    this.Gurdiansign = "";
  }
  sign1() {
    this.clientsign = this.Pad.toDataURL();
  }
  ClearEmployeeSignature3() {
    this.Pad.clear();
    this.clientsign = "";
  }

  clientsign: string = "";
  public signaturePadOptions: Object = {
    minWidth: 5,
    canvasWidth: 500,
    canvasHeight: 200,
    maxWidth: 2,
    penColor: "blue",
  };
  public versionform: FormGroup;
  public Document1: FormGroup;
  public dh1form: FormGroup;
  public statusform: FormGroup;
  public EmployeeWithholding: FormGroup;
  avoidgetId: string;
  DSwstudyBolist = [];
  Section1Form: FormGroup
  Section2Form: FormGroup
  dateForm:FormGroup
  showPassAccountRouting:FormGroup;
  @ViewChild("pdfOnboardinglistEmp") pdfOnboardinglistEmp;
  constructor(
    public employeeService: EmployeeService,
    public general: GeneralService,
    public commonStatehttp: CommonHttpService,
    public toastrService: ToastrService,
    public global: GlobalComponent,
    public dateservice: DateService,
    private formBuilder: FormBuilder,
    public agreementService: EmployeeAgreementService,
    public datepipe: DatePipe,
    public commonhttp: CommonHttpService,
    private employeeTemplateservice: EmployeeAgreementTemplateService,
   public formbuilder:FormBuilder,
   public configurationservice:ConfigurationService,
   @Inject(EmployeePayrollService) public EmployeePayrollService :EmployeePayrollService

  ) {
    this.Section1Form = new FormGroup({
      
      input1: new FormControl(''),
      input2:new FormControl(''),
      input3:new FormControl(''),
      input4:new FormControl(''),
      input5:new FormControl(''),
      input6:new FormControl(''),
      input7: new FormControl(''),
      input8: new FormControl('')
  }),
  this.Section2Form = new FormGroup({
    input1: new FormControl(''),
    input2:new FormControl(''),
    input3:new FormControl(''),
   
}),
this.dateForm=new FormGroup({
  signDate1:new FormControl(''),
  signDate2:new FormControl(''),
  signDate3:new FormControl(''),
  signDate4:new FormControl(''),
  signDate5:new FormControl(''),
  signDate6:new FormControl(''),
  signDate7:new FormControl(''),
  signDate8:new FormControl(''),
  signDate9:new FormControl(''),
  signDate10:new FormControl(''),
  signDate11:new FormControl(''),
  signDate12:new FormControl(''),
  signDate13:new FormControl(''),
  signDate14:new FormControl(''),
  signDate15:new FormControl('')

})
this.showPassAccountRouting = new FormGroup({
  Password: new FormControl('', [Validators.required])
});

}

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  stateList: any = [];
  covername: string;
  public formatOptions: object;
  fp:functionpermission=new functionpermission()
  ngOnInit(): void {  
    console.log(this.emitemployeeBO,"this.emitemployeeBO"); 
    console.log(this.global.OnboardingLoginType,"this.global.OnboardingLoginType") 
    this.individualDirectSupportBo.organizationName = this.global.agencyName;
    this.getGenderList();
    this.getEmployerType();
  // if(this.global.OnboardingLoginType !='onboardLogin'){
    this.GetEmployeeClientRelationshipList();
    this.GetEmployeePayrateList();
    this.getclientDetails();
    this.getEmployeeDetails();
  // }

    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });
   
    if (this.emitemployeeBO.addnew) {
      this.getTemplateDetails();
    } else { 
      console.log("Else calling get Aggrement Details");
      setTimeout(s=>{
        this.getAgreementDetails();
      },1000)
    }


    
    this.DSwstudyBolist.push(this.DSwstudyBolistarray);
   if(this.global.OnboardingLoginType != "onboardLogin"){
    if(this.emitemployeeBO?.iscompleted) {
      this.dateForm.disable();
    }
   // this.dateForm.disable();
  //   signDate1:new FormControl(''),
  // signDate2:new FormControl(''),
  // signDate3:new FormControl(''),
  // signDate4:new FormControl(''),
  // signDate5:new FormControl(''),
  // signDate6:new FormControl(''),
  // signDate7:new FormControl(''),
  // signDate8:new FormControl(''),
  // signDate9:new FormControl(''),
  // signDate10:new FormControl(''),
  // signDate11:new FormControl(''),
  // signDate12:new FormControl(''),
  // signDate13:new FormControl(''),
    //this.dateForm.get('signDate1').disable();
   }
   else{
    this.dateForm.enable();
   }
   if(this.emitemployeeBO.iscompleted) {
    this.Section1Form.enable();
    this.Section2Form.enable();
   } else {
    this.Section1Form.enable();
    this.Section2Form.enable();
   }
  }

  clicktab(i, list) {
    if (i >= 0) {
      this.DSwstudyBolist[i].isadd = false;
    }
    let ab = {
      bsgNumber: null,
      applicationNumber: null,
      facilityId: null,
      isadd: true,
      id:"00000000-0000-0000-0000-000000000000"
    };
    this.DSwstudyBolist.push(ab);
  }

  removeTab(i) {
    this.DSwstudyBolist.splice(i, 1);
    var length = this.DSwstudyBolist.length;
    var count = 0;
    this.DSwstudyBolist.forEach((element) => {
      if (element.isadd == false) {
        count++;
      }
    });
    if (length == count) {
      this.DSwstudyBolist[length - 1].isadd = true;
    }
  }

  supportname() {}

  suptwrkName() {}

  onDateChangedCareAUTHStart(i, event: IMyDateModel) {
    this.PreviousName[i].previous_name_date = event.formatted;
  }
  CareAUTHStartDatengModelChange;

  CareAUTHStartDatechange(i, event: IMyInputFieldChanged) {
    let value = event.value;

    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.PreviousName[i].previous_name_date =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  onDateChangedCareAUTHStart1(i, event: IMyDateModel) {}

  CareAUTHStartDatechange1(i, event: IMyInputFieldChanged) {}

  increase = [];
  increase2 = [];
  previous = {};
  previousAddress = {};

  localdata: any = [];
  editbool: boolean = false;
  dropdata: any = [];
  tablein: any = {};
  tablearr: any = [];

  hello(val) {}
  option_A(val) {}
  option_B(val) {}
  option_C(val) {}
  option_D(val) {}
  option_E(val) {}
  option_F(val) {}
  //delete_data: OnboardDocumentBO = new OnboardDocumentBO();

  get_delete_data(data) {
    // this.delete_data = data
  }
  application_cover: string = "";

  @ViewChild("SupportworkerPad") SupportworkerPad: SignaturePad;
  @ViewChild("depositPad") depositPad: SignaturePad;
  @ViewChild("SignatureIndividualPad") SignatureIndividualPad: SignaturePad;
  supportsign = "";
  drawCompetesupportsign() {
    this.supportsign = this.SupportworkerPad.toDataURL();
  }
  clearsupportsign() {
    this.SupportworkerPad.clear();
    this.supportsign = "";
  }
  individualsign = "";
  drawCompeteindividualsign() {
    this.individualsign = this.SignatureIndividualPad.toDataURL();
  }
  clearindividualsign() {
    this.SignatureIndividualPad.clear();
    this.individualsign = "";
  }
  create() {
    this.clientsign1 = this.EnPad.toDataURL();
  }
  clientsign1: string = "";
  ClearEmployeeSignature5() {
    this.EnPad.clear();
    this.clientsign1 = "";
  }
  create2() {
    this.clientsign2 = this.depositPad.toDataURL();
  }

  clientsign2: string = "";
  ClearEmployeeSignature6() {
    this.depositPad.clear();
    this.clientsign2 = "";
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  draw() {
    this.Gurdsign = this.rollPad.toDataURL();
  }
  Gurdsign: string = "";
  ClearEmployeeSignature4() {
    this.rollPad.clear();
    this.Gurdsign = "";
  }
  draw1() {
    this.Gurdsign1 = this.rollPad1.toDataURL();
  }

  Gurdsign1: string = "";
  ClearEmployeeSignature7() {
    this.rollPad1.clear();
    this.Gurdsign1 = "";
  }

  draw2() {
    this.Gurdsign2 = this.rollPad2.toDataURL();
  }

  Gurdsign2: string = "";
  ClearEmployeeSignature8() {
    this.rollPad2.clear();
    this.Gurdsign2 = "";
  }

  draw3() {
    this.Gurdsign3 = this.rollPad3.toDataURL();
  }

  Gurdsign3: string = "";
  ClearEmployeeSignature9() {
    this.rollPad3.clear();
    this.Gurdsign3 = "";
  }

  draw4() {
    this.Gurdsign4 = this.rollPad4.toDataURL();
  }

  Gurdsign4: string = "";
  ClearEmployeeSignature0() {
    this.rollPad4.clear();
    this.Gurdsign4 = "";
  }

  appsign() {
    this.sign3 = this.appsignpad.toDataURL();
  }

  sign3: string = "";
  Clearapp() {
    this.appsignpad.clear();
    this.sign3 = "";
  }
  appsign1: any;
  parentsign1() {
    this.appsign1 = this.authsignpad.toDataURL();

  }
  parentsign() {
    this.sign4 = this.parentsignpad.toDataURL();
  }

  sign4: string = "";
  Clearparent() {
    this.authsignpad.clear();
    this.appsign1 = "";
  }
  Clearparent2() {
    this.parentsignpad.clear();
    this.sign4 = "";
  }

  @ViewChild("TranslatorSignaturePad") TranslatorSignaturePad: SignaturePad;
  translatorsign = "";
  drawCompetetranslatorsign() {
    this.translatorsign = this.TranslatorSignaturePad.toDataURL();
  }
  cleartranslatorsign() {
    this.TranslatorSignaturePad.clear();
    this.translatorsign = "";
  }
  @ViewChild("AuthorizedSignaturePad") AuthorizedSignaturePad: SignaturePad;
  authorizedsign = "";
  drawCompeteauthorizedsign() {
    this.authorizedsign = this.AuthorizedSignaturePad.toDataURL();
  }
  clearauthorizedsign() {
    this.AuthorizedSignaturePad.clear();
    this.authorizedsign = "";
  }
  @ViewChild("AuthorizedRepSignaturePad")
  AuthorizedRepSignaturePad: SignaturePad;
  authorizedrepsign = "";
  drawCompeteauthorizedRepsign() {
    this.authorizedrepsign = this.AuthorizedRepSignaturePad.toDataURL();
  }
  clearauthorizedRepsign() {
    this.AuthorizedRepSignaturePad.clear();
    this.authorizedrepsign = "";
  }
  @ViewChild("EmployeeSignaturePad") EmployeeSignaturePad: SignaturePad;
  employeesign = "";
  drawCompeteemployeesign() {
    this.employeesign = this.EmployeeSignaturePad.toDataURL();
  }
  clearemployeesign() {
    this.EmployeeSignaturePad.clear();
    this.employeesign = "";
  }
  @ViewChild("WageRepSignaturePad") WageRepSignaturePad: SignaturePad;
  repemployeesign = "";
  drawCompeteRepemployeesign() {
    this.repemployeesign = this.WageRepSignaturePad.toDataURL();
  }
  clearRepemployeesign() {
    this.WageRepSignaturePad.clear();
    this.repemployeesign = "";
  }

  @ViewChild("ageRepSignaturePad") ageRepSignaturePad: SignaturePad;
  repsign = "";
  drawCompeteRepsign() {
    this.repsign = this.ageRepSignaturePad.toDataURL();
  }
  clearRepsign() {
    this.ageRepSignaturePad.clear();
    this.repsign = "";
  }
  closeSignarueModal() {
    document.getElementById("i9FormModal").click();
  }
  closeBackModal1() {
    document.getElementById("BackModal1").click();
  }
  closeBackModal2() {
    document.getElementById("BackModal2").click();
  }
  closeBackModal3() {
    document.getElementById("BackModal3").click();
  }
  closeDHS_4469AModal1() {
    document.getElementById("DHS_4469AModal1").click();
  }
  closeDHS_4469AModal2() {
    document.getElementById("DHS_4469AModal2").click();
  }
  closeEmployeeGenModal1() {
    document.getElementById("Employee_GenModal1").click();
  }
  closeEmployeeGenModal2() {
    document.getElementById("Employee_GenModal2").click();
  }
  closeFEAModal1() {
    document.getElementById("FEA_EmpModal1").click();
  }
  closeWageModal1() {
    document.getElementById("WageModal1").click();
  }
  closeageModal1() {
    document.getElementById("ageModal1").click();
  }
  closeTranslatorModal() {
    document.getElementById("TranslatorModal").click();
  }
  closeAuthorizedModal() {
    document.getElementById("AuthorizedModal").click();
  }
  closeAuthorizedRepModal() {
    document.getElementById("AuthorizedRepModal").click();
  }
  closeNurseModal() {
    document.getElementById("NurseSignModal").click();
  }
  closeNurseSignModal() {
    document.getElementById("NurseSign").click();
  }

  //genderlist: [{ Key: string; Value: string }];

  // getgender() {
  //   //  {
  //   if (this.employeeBO.edit == true) {
  //     let params = new URLSearchParams();
  //     params.append("Code", "GENDER");
  //     this.employeeservice
  //       .getGenderLov(params)
  //       .pipe(takeUntil(this.onDestroy$))
  //       .subscribe((data: [{ Key: string; Value: string }]) => {
  //         this.genderlist = data;
  //       });
  //   } else {
  //     let params = new URLSearchParams();
  //     params.append("Code", "GENDER");
  //     this.employeeservice
  //       .getcomman(params)
  //       .pipe(takeUntil(this.onDestroy$))
  //       .subscribe((data: [{ Key: string; Value: string }]) => {
  //         this.genderlist = data;
  //       });
  //   }
  // }

  public DocType: any;
  type_of_DocKey: string;
  public isEdit_doctype: boolean = false;

  IsduplicateForm: boolean = false;

  gridListData: any = [];

  gridDocName: string;
  gridname(data) {
    this.gridDocName = data.documentName;
  }

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$";
  getId: string;
  docId: string;
  getdeleteid: string;
  saveErr: any = "";
  work_allowed(val) {}
  hire(val) {}


  checkValue_single1(val) {}
  w4_fun_marriedheld(val) {}
  one_bool(val) {}
  clickone(val) {}
  zip1 = false;
  zip2 = false;
  zip3 = false;
  zip4 = false;
  zip5 = false;
  zip6 = false;
  zip7 = false;
  ziperr = "";
  ssn = false;
  ssn1 = false;
  ssn2 = false;
  ssn3 = false;
  ssn4 = false;
  ssnerror = "";
  checkssn() {
    if (
      this.individualDirectSupportBo.ssn != null &&
      this.individualDirectSupportBo.ssn != "" &&
      this.individualDirectSupportBo.ssn != undefined
    ) {
      if (this.individualDirectSupportBo.ssn.length >= 7) {
        this.ssn = false;
      } else {
        this.ssn = true;
        this.ssnerror = "Enter 9 digit SSN";
      }
    }
    if (
      this.employmentEligibilityBo.us_Ssn != null &&
      this.employmentEligibilityBo.us_Ssn != "" &&
      this.employmentEligibilityBo.us_Ssn != undefined
    ) {
      if (this.employmentEligibilityBo.us_Ssn.length >= 7) {
        this.ssn1 = false;
      } else {
        this.ssn1 = true;
        this.ssnerror = "Enter 9 digit SSN";
      }
    }
    if (
      this.employeesWithholdingBo.social_Security_Number != null &&
      this.employeesWithholdingBo.social_Security_Number != "" &&
      this.employeesWithholdingBo.social_Security_Number != undefined
    ) {
      if (this.employeesWithholdingBo.social_Security_Number.length >= 7) {
        this.ssn2 = false;
      } else {
        this.ssn2 = true;
        this.ssnerror = "Enter 9 digit SSN";
      }
    }
    if (
      this.w4MinnesotaWithholdingBo.socialSecurityNumber != null &&
      this.w4MinnesotaWithholdingBo.socialSecurityNumber != "" &&
      this.w4MinnesotaWithholdingBo.socialSecurityNumber != undefined
    ) {
      if (this.w4MinnesotaWithholdingBo.socialSecurityNumber.length >= 7) {
        this.ssn3 = false;
      } else {
        this.ssn3 = true;
        this.ssnerror = "Enter 9 digit SSN";
      }
    }
    if (
      this.backgroundBo.ssn != "" &&
      this.backgroundBo.ssn != null &&
      this.backgroundBo.ssn != undefined
    ) {
      if (this.backgroundBo.ssn.length >= 7) {
        this.ssn4 = false;
      } else {
        this.ssn4 = true;
        this.ssnerror = "Enter 9 digit SSN";
      }
    }
  }
  validZip() {
    if (
      this.backgroundBo.zip != "" &&
      this.backgroundBo.zip != null &&
      this.backgroundBo.zip != undefined
    ) {
      if (this.backgroundBo.zip.length < 4) {
        this.zip1 = true;
        this.ziperr = "Invalid zipcode";
      } else {
        this.zip1 = false;
      }
    }
    if (
      this.individualDirectSupportBo.zip != null &&
      this.individualDirectSupportBo.zip != "" &&
      this.individualDirectSupportBo.zip != undefined
    ) {
      if (this.individualDirectSupportBo.zip.length < 4) {
        this.zip2 = true;
        this.ziperr = "Invalid zipcode";
      } else {
        this.zip2 = false;
      }
    }
    // if (
    //   this.employmentEligibilityBo.zip != null &&
    //   this.employmentEligibilityBo.zip != "" &&
    //   this.employmentEligibilityBo.zip != undefined
    // ) {
    //   if (this.employmentEligibilityBo.zip.length < 4) {
    //     this.zip3 = true;
    //     this.ziperr = "Invalid zipcode";
    //   } else {
    //     this.zip3 = false;
    //   }
    // }
    if (
      this.employmentEligibilityBo.preparerZip != null &&
      this.employmentEligibilityBo.preparerZip != "" &&
      this.employmentEligibilityBo.preparerZip != undefined
    ) {
      if (this.employmentEligibilityBo.preparerZip.length < 4) {
        this.zip4 = true;
        this.ziperr = "Invalid zipcode";
      } else {
        this.zip4 = false;
      }
    }

    if (
      this.employmentEligibilityBo.employersZip != null &&
      this.employmentEligibilityBo.employersZip != "" &&
      this.employmentEligibilityBo.employersZip != undefined
    ) {
      if (this.employmentEligibilityBo.employersZip.length < 4) {
        this.zip5 = true;
        this.ziperr = "Invalid zipcode";
      } else {
        this.zip5 = false;
      }
    }
    // if (
    //   this.w4MinnesotaWithholdingBo.personalZip != null &&
    //   this.w4MinnesotaWithholdingBo.personalZip != "" &&
    //   this.w4MinnesotaWithholdingBo.personalZip != undefined
    // )
    // {
    //   if (this.w4MinnesotaWithholdingBo.personalZip.length < 4) {
    //     this.zip6 = true;
    //     this.ziperr = "Invalid zipcode";
    //   } else {
    //     this.zip6 = false;
    //   }
    // }
    if (
      this.w4MinnesotaWithholdingBo.employerZip != null &&
      this.w4MinnesotaWithholdingBo.employerZip != "" &&
      this.w4MinnesotaWithholdingBo.employerZip != undefined
    ) {
      if (this.w4MinnesotaWithholdingBo.employerZip.length < 4) {
        this.zip7 = true;
        this.ziperr = "Invalid zipcode";
      } else {
        this.zip7 = false;
      }
    }
  }

  saveAgreement() {
    this.isSaveorUpdateBoolean=true;
    this.relationshipBo.relationshipName=this.reationshipname
    this.backgroundBo.dob =(
      this.backgroundBo.dob != null &&
      this.backgroundBo.dob != undefined &&
      this.backgroundBo.dob != "")
        ? this.global.getDateTimeString(this.backgroundBo.dob)
        : null;
    this.backgroundBo.previousNamesUsedDate1 =(
      this.backgroundBo.previousNamesUsedDate1 != null &&
      this.backgroundBo.previousNamesUsedDate1 != undefined &&
      this.backgroundBo.previousNamesUsedDate1 != "")

        ? this.global.getDateTimeString(
            this.backgroundBo.previousNamesUsedDate1
          )
        : null;
    this.backgroundBo.previousNamesUsedDate2 =(
      this.backgroundBo.previousNamesUsedDate2 != null &&
      this.backgroundBo.previousNamesUsedDate2 != undefined &&
      this.backgroundBo.previousNamesUsedDate2 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previousNamesUsedDate2
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate1 =(
      this.backgroundBo.previous_Addresses_UsedDate1 != null &&
      this.backgroundBo.previous_Addresses_UsedDate1 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate1 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate1
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate2 =(
      this.backgroundBo.previous_Addresses_UsedDate2 != null &&
      this.backgroundBo.previous_Addresses_UsedDate2 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate2 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate2
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate3 =(
      this.backgroundBo.previous_Addresses_UsedDate3 != null &&
      this.backgroundBo.previous_Addresses_UsedDate3 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate3 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate3
          )
        : null;

    this.backgroundBo.applicantSignatureDate =(
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.applicantSignatureDate
          )
        : null;
    this.backgroundBo.parentSignatureDate =(
      this.backgroundBo.parentSignatureDate != null &&
      this.backgroundBo.parentSignatureDate != undefined &&
      this.backgroundBo.parentSignatureDate != "")
        ? this.global.getDateTimeString(this.backgroundBo.parentSignatureDate)
        : null;
    this.payNoticeBo.employeeSignDate =(
      this.payNoticeBo.employeeSignDate != null &&
      this.payNoticeBo.employeeSignDate != undefined &&
      this.payNoticeBo.employeeSignDate != "")
        ? this.global.getDateTimeString(this.payNoticeBo.employeeSignDate)
        : null;
    this.payNoticeBo.employerSignDate =(
      this.payNoticeBo.employerSignDate != null &&
      this.payNoticeBo.employerSignDate != undefined &&
      this.payNoticeBo.employerSignDate != "")
        ? this.global.getDateTimeString(this.payNoticeBo.employerSignDate)
        : null;

    this.relationshipBo.dob =(
      this.relationshipBo.dob != null &&
      this.relationshipBo.dob != undefined &&
      this.relationshipBo.dob != "")
        ? this.global.getDateTimeString(this.relationshipBo.dob)
        : null;
    this.relationshipBo.applicantSignDate =(
      this.relationshipBo.applicantSignDate != null &&
      this.relationshipBo.applicantSignDate != undefined &&
      this.relationshipBo.applicantSignDate != "")
        ? this.global.getDateTimeString(this.relationshipBo.applicantSignDate)
        : null;
    this.relationshipBo.employersSignDate =(
      this.relationshipBo.employersSignDate != null &&
      this.relationshipBo.employersSignDate != undefined &&
      this.relationshipBo.employersSignDate != "")
        ? this.global.getDateTimeString(this.relationshipBo.employersSignDate)
        : null;

    this.individualDirectSupportBo.previousEmployementEndDate =(
      this.individualDirectSupportBo.previousEmployementEndDate != null &&
      this.individualDirectSupportBo.previousEmployementEndDate != undefined &&
      this.individualDirectSupportBo.previousEmployementEndDate != "")
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.previousEmployementEndDate
          )
        : null;
    this.individualDirectSupportBo.dob =(
      this.individualDirectSupportBo.dob != null &&
      this.individualDirectSupportBo.dob != undefined &&
      this.individualDirectSupportBo.dob != "")
        ? this.global.getDateTimeString(this.individualDirectSupportBo.dob)
        : null;

    this.individualDirectSupportBo.optionalTrainingCompletionDate =(
      this.individualDirectSupportBo.optionalTrainingCompletionDate != null &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate !=
        undefined &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate != "")
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.optionalTrainingCompletionDate
          )
        : null;
    this.individualDirectSupportBo.optionalTrainingExpirationDate =(
      this.individualDirectSupportBo.optionalTrainingExpirationDate != null &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != "" &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != undefined)
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.optionalTrainingExpirationDate
          )
        : null;
    this.employmentEligibilityBo.dob =(
      this.employmentEligibilityBo.dob != null &&
      this.employmentEligibilityBo.dob != undefined &&
      this.employmentEligibilityBo.dob != "")
        ? this.global.getDateTimeString(this.employmentEligibilityBo.dob)
        : null;
    this.employmentEligibilityBo.alien_Registration_ExpiryDate =(
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != null &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != undefined &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.alien_Registration_ExpiryDate
          )
        : null;

    this.employmentEligibilityBo.todaysDate =(
      this.employmentEligibilityBo.todaysDate != null &&
      this.employmentEligibilityBo.todaysDate != undefined &&
      this.employmentEligibilityBo.todaysDate != "")
        ? this.global.getDateTimeString(this.employmentEligibilityBo.todaysDate)
        : null;

    this.employmentEligibilityBo.signOfPreparerorTraslatorDate =(
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != null &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != undefined &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.signOfPreparerorTraslatorDate
          )
        : null;

    this.employmentEligibilityBo.expirationDate =(
      this.employmentEligibilityBo.expirationDate != null &&
      this.employmentEligibilityBo.expirationDate != undefined &&
      this.employmentEligibilityBo.expirationDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate
          )
        : null;

    this.employmentEligibilityBo.expirationDate1 =(
      this.employmentEligibilityBo.expirationDate1 != null &&
      this.employmentEligibilityBo.expirationDate1 != undefined &&
      this.employmentEligibilityBo.expirationDate1 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate1
          )
        : null;
    this.employmentEligibilityBo.expirationDate2 =(
      this.employmentEligibilityBo.expirationDate2 != null &&
      this.employmentEligibilityBo.expirationDate2 != undefined &&
      this.employmentEligibilityBo.expirationDate2 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate2
          )
        : null;
    this.employmentEligibilityBo.expirationDate3 =(
      this.employmentEligibilityBo.expirationDate3 != null &&
      this.employmentEligibilityBo.expirationDate3 != undefined &&
      this.employmentEligibilityBo.expirationDate3 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate3
          )
        : null;
    this.employmentEligibilityBo.expirationDate4 =(
      this.employmentEligibilityBo.expirationDate4 != null &&
      this.employmentEligibilityBo.expirationDate4 != undefined &&
      this.employmentEligibilityBo.expirationDate4 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate4
          )
        : null;

    this.employmentEligibilityBo.employeesFirstdayEmployment =(
      this.employmentEligibilityBo.employeesFirstdayEmployment != null &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != undefined &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.employeesFirstdayEmployment
          )
        : null;
    this.individualSupportWorkerBo.signDate =(
      this.individualSupportWorkerBo.signDate != null &&
      this.individualSupportWorkerBo.signDate != undefined &&
      this.individualSupportWorkerBo.signDate != "")
        ? this.global.getDateTimeString(this.individualSupportWorkerBo.signDate)
        : null;

    this.individualDirectSupportBo.signDate = (
      this.individualDirectSupportBo.signDate != null &&
      this.individualDirectSupportBo.signDate != undefined &&
      this.individualDirectSupportBo.signDate != "")
     ? this.global.getDateTimeString(this.individualDirectSupportBo.signDate)
    : null;

    this.employmentEligibilityBo.employerSignDate1 =(
      this.employmentEligibilityBo.employerSignDate1 != null &&
      this.employmentEligibilityBo.employerSignDate1 != undefined &&
      this.employmentEligibilityBo.employerSignDate1 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.employerSignDate1
          )
        : null;

    this.employmentEligibilityBo.reverificationDate =(
      this.employmentEligibilityBo.reverificationDate != null &&
      this.employmentEligibilityBo.reverificationDate != undefined &&
      this.employmentEligibilityBo.reverificationDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.reverificationDate
          )
        : null;

    this.employmentEligibilityBo.documentExpiryDate =(
      this.employmentEligibilityBo.documentExpiryDate != null &&
      this.employmentEligibilityBo.documentExpiryDate != undefined &&
      this.employmentEligibilityBo.documentExpiryDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.documentExpiryDate
          )
        : null;

    this.employmentEligibilityBo.employerSignDate3 =(
      this.employmentEligibilityBo.employerSignDate3 != null &&
      this.employmentEligibilityBo.employerSignDate3 != undefined &&
      this.employmentEligibilityBo.employerSignDate3 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.employerSignDate3
          )
        : null;

    this.employeesWithholdingBo.signDate =(
      this.employeesWithholdingBo.signDate != null &&
      this.employeesWithholdingBo.signDate != undefined &&
      this.employeesWithholdingBo.signDate != "")
        ? this.global.getDateTimeString(this.employeesWithholdingBo.signDate)
        : null;

    this.employeesWithholdingBo.firstDateOfEmployeement =(
      this.employeesWithholdingBo.firstDateOfEmployeement != null &&
      this.employeesWithholdingBo.firstDateOfEmployeement != undefined &&
      this.employeesWithholdingBo.firstDateOfEmployeement != "")
        ? this.global.getDateTimeString(
            this.employeesWithholdingBo.firstDateOfEmployeement
          )
        : null;

    this.w4MinnesotaWithholdingBo.date =(
      this.w4MinnesotaWithholdingBo.date != null &&
      this.w4MinnesotaWithholdingBo.date != undefined &&
      this.w4MinnesotaWithholdingBo.date != "")
        ? this.global.getDateTimeString(this.w4MinnesotaWithholdingBo.date)
        : null;

    this.agreementBo.backgroundStudyAuthorization = this.backgroundBo;

    this.agreementBo.employeeAgreementAndDirectDeposit =
      this.employeeAgreementBo;
    this.agreementBo.employeeApplicationCover = this.employeeApplicationBo;
    this.agreementBo.employeesWithholdingCertificate =
      this.employeesWithholdingBo;
    this.agreementBo.employmentEligibilityVerification =
      this.employmentEligibilityBo;
    this.DSwstudyBo = this.DSwstudyBolist;
    this.individualDirectSupportBo.dswBackgroundStudyInfoForms =
      this.DSwstudyBo;
    this.agreementBo.individualDirectSupportWorkerEnrollmentApplication =
      this.individualDirectSupportBo;

    this.agreementBo.individualSupportWorkerProviderAgreement =
      this.individualSupportWorkerBo;
     this.payNoticeBo.payNoticePayrateDetails=this.PayNoticePayrateDetailBo
    this.agreementBo.payNotice = this.payNoticeBo;
    this.relationshipBo.relationshipDisclosureTaxDetails =
      this.relationdisclosureBo;
    this.agreementBo.relationshipDisclosure = this.relationshipBo;
    this.agreementBo.w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipients =
      this.w4MNInstructionsBo;
    this.agreementBo.w4MinnesotaWithholdingAllowanceOrExemptionCertificate =
      this.w4MinnesotaWithholdingBo;

    this.backgroundBo.applicantSignature = this.appsign1;
    this.backgroundBo.parentSignature = this.sign4;

    this.payNoticeBo.employeeSign = this.Gurdsign3;
    this.payNoticeBo.employerSign = this.employeesign2;

    this.relationshipBo.employersSign = this.clientsign0;
    this.relationshipBo.applicantSign = this.employeesign3;
    this.employeeAgreementBo.employee_sign = this.clientsign2;

    this.individualDirectSupportBo.sign = this.individualsign;

    this.individualSupportWorkerBo.sign = this.repsign;

    this.employmentEligibilityBo.signOfEmployee = this.employeesign;
    this.employmentEligibilityBo.employerSign = this.translatorsign;

    this.employmentEligibilityBo.employerSign1 = this.authorizedsign;
    this.employmentEligibilityBo.signOfPreparerorTraslator =
      this.authorizedrepsign;

    this.employeesWithholdingBo.employeeSignature = this.Gurdsign;
    this.w4MinnesotaWithholdingBo.signature = this.clientsign1;

    this.agreementBo.clientId = this.emitemployeeBO.clientid;
    this.agreementBo.employeeId = this.emitemployeeBO.employeeid;
    this.agreementBo.id = this.emitemployeeBO.agreementId;

   let getlogin= localStorage.getItem("onboardLoginUser")
   console.log(this.global.OnboardingLoginType)
    if (this.global.OnboardingLoginType != "onboardLogin") {
      this.agreementService
        .saveEmployeeAgreement(this.agreementBo)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.isSaveorUpdateBoolean=false;

           
           if(this.emitemployeeBO.agreementId=="00000000-0000-0000-0000-000000000000"){
            this.toastrService.success("Employee Agreement Saved Successfully");
            this.emitemployeeBO.agreementId = JSON.parse(data);
          }
          else{
            this.toastrService.success("Employee Agreement Updated Successfully");
          }
            this.DataToClientOnBoardList();
            // this.getAgreementDetails();
          },
          (err: HttpErrorResponse) => {
            this.isSaveorUpdateBoolean=false;
            this.toastrService.error(err.error, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
    } 
    else if(getlogin=="EMPLOYEE") {
      this.agreementService
        .saveEmployeeDocPortal(this.agreementBo)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.isSaveorUpdateBoolean=false;
            this.toastrService.success("Employee Agreement Saved Successfully");
            this.DataToClientOnBoardList();
            // this.getAgreementDetails();
          },
          (err: HttpErrorResponse) => {
            this.isSaveorUpdateBoolean=false;
            this.toastrService.error(err.error, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
    }
    else if( getlogin=="CLIENT"){
      this.agreementService
      .saveEmployeeDocClientPortal(this.agreementBo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.isSaveorUpdateBoolean=false;
          this.toastrService.success("Employer Agreement Submitted Successfully");
          this.DataToClientOnBoardList();
          // this.getAgreementDetails();
        },
        (err: HttpErrorResponse) => {
          this.isSaveorUpdateBoolean=false;
          this.toastrService.error(err.error, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
    }
  }

  getAgreementDetails() {
    let params = new URLSearchParams();
    params.append("AggrementId", this.emitemployeeBO.agreementId);
    this.agreementService
      .getAgreementDocumentPoratalDetails(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {      
       if(this.emitemployeeBO.iscompleted) {
        this.Section1Form.disable();
        this.Section2Form.disable();
       } else {
        this.Section1Form.enable();
        this.Section2Form.enable();
       }
        let doc_data=JSON.parse(data);
        this.backgroundBo = doc_data.backgroundStudyAuthorization;
        if(this.backgroundBo != undefined && this.backgroundBo != null) {
          this.prepopulatevalue.ssn=this.backgroundBo.ssn;
          this.prepopulatevalue.middleName=this.backgroundBo.middleName;
          this.prepopulatevalue.driverLicense=this.backgroundBo.driver_LicenseNo;
          this.prepopulatevalue.placeofBirth=this.backgroundBo.placeofBirth;          
        }
       // console.log("this.prepopulatevalue---",this.prepopulatevalue);
        this.employeeAgreementBo = doc_data.employeeAgreementAndDirectDeposit;
        this.employeeApplicationBo = doc_data.employeeApplicationCover;
        this.employeesWithholdingBo = doc_data.employeesWithholdingCertificate;
        this.employmentEligibilityBo = doc_data.employmentEligibilityVerification;
        if(this.employmentEligibilityBo != null && this.employeeApplicationBo !=undefined) {
          this.prepopulatevalue.apt = this.employmentEligibilityBo.apt ;         
         
        }
        if(this.employeeAgreementBo !=null && this.employeeAgreementBo != undefined) {
          this.tempAccNo=this.employeeAgreementBo.account;
          this.tempRouting=this.employeeAgreementBo.routing;
        console.log(this.tempRouting,this.tempAccNo,"Assign TempRouting,TempAccNo");
        }
        console.log("this.prepopulatevalue---",this.prepopulatevalue);
        doc_data.individualDirectSupportWorkerEnrollmentApplication;
        this.individualSupportWorkerBo =
        doc_data.individualSupportWorkerProviderAgreement;
        this.payNoticeBo = doc_data.payNotice;
        this.relationshipBo = doc_data.relationshipDisclosure;
        this.employeesWithholdingBo.maritialStatus = doc_data.employeesWithholdingCertificate.maritialStatus;
        this.individualDirectSupportBo = doc_data.individualDirectSupportWorkerEnrollmentApplication;
        this.w4MinnesotaWithholdingBo =
        doc_data.w4MinnesotaWithholdingAllowanceOrExemptionCertificate;
        this.w4MNInstructionsBo =
        doc_data.w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipients;
         this.DSwstudyBolist = doc_data.individualDirectSupportWorkerEnrollmentApplication.dswBackgroundStudyInfoForms;
           if(this.DSwstudyBolist.length == 0) {
            this.DSwstudyBolist = [
{
  bsgNumber: null,
  applicationNumber: null,
  facilityId: null,
  isadd: true,
}

            ]
           }
           this.w4MinnesotaWithholdingBo.phoneNumber =doc_data.w4MinnesotaWithholdingAllowanceOrExemptionCertificate.phoneNumber
           

         
        this.appsign1 = this.backgroundBo.applicantSignature;
        this.sign4 = this.backgroundBo.parentSignature;

        this.Gurdsign3 = this.payNoticeBo.employeeSign;
        this.employeesign2 = this.payNoticeBo.employerSign;

        this.clientsign0 = this.relationshipBo.employersSign;
        this.employeesign3 = this.relationshipBo.applicantSign;
        this.clientsign2 = this.employeeAgreementBo.employee_sign;

        this.individualsign = this.individualDirectSupportBo.sign;

        this.repsign = this.individualSupportWorkerBo.sign;

        this.employeesign = this.employmentEligibilityBo.signOfEmployee;
        this.translatorsign = this.employmentEligibilityBo.employerSign;
        this.authorizedsign = this.employmentEligibilityBo.employerSign1;
        this.authorizedrepsign =
          this.employmentEligibilityBo.signOfPreparerorTraslator;

        this.Gurdsign = this.employeesWithholdingBo.employeeSignature;
        this.clientsign1 = this.w4MinnesotaWithholdingBo.signature;

        this.individualDirectSupportBoRadio1=JSON.stringify(this.individualDirectSupportBo.isMcoClaimsOnly)
        this.individualDirectSupportBoRadio2=JSON.stringify(this.individualDirectSupportBo.isQualifiedEnhancedRateTraining)
        this.individualDirectSupportBoRadio3=JSON.stringify(this.individualDirectSupportBo.isAffiliateIndividualDsw)
        
        this.spouse =JSON.stringify(this.relationshipBo.employerandWantWorkers)
        
        this.backgroundBo.dob =
          this.backgroundBo.dob != null &&
          this.backgroundBo.dob != undefined &&
          this.backgroundBo.dob != ""
            ? this.datepipe.transform(this.backgroundBo.dob, "MM/dd/yyyy")
            : null;
        this.backgroundBo.previousNamesUsedDate1 =
          this.backgroundBo.previousNamesUsedDate1 != null &&
          this.backgroundBo.previousNamesUsedDate1 != undefined &&
          this.backgroundBo.previousNamesUsedDate1 != ""
            ? this.datepipe.transform(
                this.backgroundBo.previousNamesUsedDate1,
                "MM/dd/yyyy"
              )
            : null;
        this.backgroundBo.previousNamesUsedDate2 =
          this.backgroundBo.previousNamesUsedDate2 != null &&
          this.backgroundBo.previousNamesUsedDate2 != undefined &&
          this.backgroundBo.previousNamesUsedDate2 != ""
            ? this.datepipe.transform(
                this.backgroundBo.previousNamesUsedDate2,
                "MM/dd/yyyy"
              )
            : null;
        this.backgroundBo.previous_Addresses_UsedDate1 =
          this.backgroundBo.previous_Addresses_UsedDate1 != null &&
          this.backgroundBo.previous_Addresses_UsedDate1 != undefined &&
          this.backgroundBo.previous_Addresses_UsedDate1 != ""
            ? this.datepipe.transform(
                this.backgroundBo.previous_Addresses_UsedDate1,
                "MM/dd/yyyy"
              )
            : null;
        this.backgroundBo.previous_Addresses_UsedDate2 =
          this.backgroundBo.previous_Addresses_UsedDate2 != null &&
          this.backgroundBo.previous_Addresses_UsedDate2 != undefined &&
          this.backgroundBo.previous_Addresses_UsedDate2 != ""
            ? this.datepipe.transform(
                this.backgroundBo.previous_Addresses_UsedDate2,
                "MM/dd/yyyy"
              )
            : null;
        this.backgroundBo.previous_Addresses_UsedDate3 =
          this.backgroundBo.previous_Addresses_UsedDate3 != null &&
          this.backgroundBo.previous_Addresses_UsedDate3 != undefined &&
          this.backgroundBo.previous_Addresses_UsedDate3 != ""
            ? this.datepipe.transform(
                this.backgroundBo.previous_Addresses_UsedDate3,
                "MM/dd/yyyy"
              )
            : null;

        this.backgroundBo.applicantSignatureDate =
          this.backgroundBo.applicantSignatureDate != null &&
          this.backgroundBo.applicantSignatureDate != null &&
          this.backgroundBo.applicantSignatureDate != ""
            ? this.datepipe.transform(
                this.backgroundBo.applicantSignatureDate,
                "MM/dd/yyyy"
              )
            : null;
        this.backgroundBo.parentSignatureDate =
          this.backgroundBo.parentSignatureDate != null &&
          this.backgroundBo.parentSignatureDate != undefined &&
          this.backgroundBo.parentSignatureDate != ""
            ? this.datepipe.transform(
                this.backgroundBo.parentSignatureDate,
                "MM/dd/yyyy"
              )
            : null;
        this.payNoticeBo.employeeSignDate =
          this.payNoticeBo.employeeSignDate != null &&
          this.payNoticeBo.employeeSignDate != undefined &&
          this.payNoticeBo.employeeSignDate != ""
            ? this.datepipe.transform(
                this.payNoticeBo.employeeSignDate,
                "MM/dd/yyyy"
              )
            : null;
        this.payNoticeBo.employerSignDate =
          this.payNoticeBo.employerSignDate != null &&
          this.payNoticeBo.employerSignDate != undefined &&
          this.payNoticeBo.employerSignDate != ""
            ? this.datepipe.transform(
                this.payNoticeBo.employerSignDate,
                "MM/dd/yyyy"
              )
            : null;

        this.relationshipBo.dob =
          this.relationshipBo.dob != null &&
          this.relationshipBo.dob != undefined &&
          this.relationshipBo.dob != ""
            ? this.datepipe.transform(this.relationshipBo.dob, "MM/dd/yyyy")
            : null;
        this.relationshipBo.applicantSignDate =
          this.relationshipBo.applicantSignDate != null &&
          this.relationshipBo.applicantSignDate != undefined &&
          this.relationshipBo.applicantSignDate != ""
            ? this.datepipe.transform(
                this.relationshipBo.applicantSignDate,
                "MM/dd/yyyy"
              )
            : null;
        this.relationshipBo.employersSignDate =
          this.relationshipBo.employersSignDate != null &&
          this.relationshipBo.employersSignDate != undefined &&
          this.relationshipBo.employersSignDate != ""
            ? this.datepipe.transform(
                this.relationshipBo.employersSignDate,
                "MM/dd/yyyy"
              )
            : null;

        this.individualDirectSupportBo.previousEmployementEndDate =
          this.individualDirectSupportBo.previousEmployementEndDate != null &&
          this.individualDirectSupportBo.previousEmployementEndDate !=
            undefined &&
          this.individualDirectSupportBo.previousEmployementEndDate != ""
            ? this.datepipe.transform(
                this.individualDirectSupportBo.previousEmployementEndDate,
                "MM/dd/yyyy"
              )
            : null;
        this.individualDirectSupportBo.dob =
          this.individualDirectSupportBo.dob != null &&
          this.individualDirectSupportBo.dob != undefined &&
          this.individualDirectSupportBo.dob != ""
            ? this.datepipe.transform(
                this.individualDirectSupportBo.dob,
                "MM/dd/yyyy"
              )
            : null;

        this.individualDirectSupportBo.optionalTrainingCompletionDate =
          this.individualDirectSupportBo.optionalTrainingCompletionDate !=
            null &&
          this.individualDirectSupportBo.optionalTrainingCompletionDate !=
            undefined &&
          this.individualDirectSupportBo.optionalTrainingCompletionDate != ""
            ? this.datepipe.transform(
                this.individualDirectSupportBo.optionalTrainingCompletionDate,
                "MM/dd/yyyy"
              )
            : null;
        this.individualDirectSupportBo.optionalTrainingExpirationDate =
          this.individualDirectSupportBo.optionalTrainingExpirationDate !=
            null &&
          this.individualDirectSupportBo.optionalTrainingExpirationDate != "" &&
          this.individualDirectSupportBo.optionalTrainingExpirationDate !=
            undefined
            ? this.datepipe.transform(
                this.individualDirectSupportBo.optionalTrainingExpirationDate,
                "MM/dd/yyyy"
              )
            : null;
        this.employmentEligibilityBo.dob =
          this.employmentEligibilityBo.dob != null &&
          this.employmentEligibilityBo.dob != undefined &&
          this.employmentEligibilityBo.dob != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.dob,
                "MM/dd/yyyy"
              )
            : null;
        this.employmentEligibilityBo.alien_Registration_ExpiryDate =
          this.employmentEligibilityBo.alien_Registration_ExpiryDate != null &&
          this.employmentEligibilityBo.alien_Registration_ExpiryDate !=
            undefined &&
          this.employmentEligibilityBo.alien_Registration_ExpiryDate != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.alien_Registration_ExpiryDate,
                "MM/dd/yyyy"
              )
            : null;

        this.employmentEligibilityBo.todaysDate =
          this.employmentEligibilityBo.todaysDate != null &&
          this.employmentEligibilityBo.todaysDate != undefined &&
          this.employmentEligibilityBo.todaysDate != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.todaysDate,
                "MM/dd/yyyy"
              )
            : null;

        this.employmentEligibilityBo.signOfPreparerorTraslatorDate =
          this.employmentEligibilityBo.signOfPreparerorTraslatorDate != null &&
          this.employmentEligibilityBo.signOfPreparerorTraslatorDate !=
            undefined &&
          this.employmentEligibilityBo.signOfPreparerorTraslatorDate != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.signOfPreparerorTraslatorDate,
                "MM/dd/yyyy"
              )
            : null;

        this.employmentEligibilityBo.expirationDate =
          this.employmentEligibilityBo.expirationDate != null &&
          this.employmentEligibilityBo.expirationDate != undefined &&
          this.employmentEligibilityBo.expirationDate != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.expirationDate,
                "MM/dd/yyyy"
              )
            : null;

        this.employmentEligibilityBo.expirationDate1 =
          this.employmentEligibilityBo.expirationDate1 != null &&
          this.employmentEligibilityBo.expirationDate1 != undefined &&
          this.employmentEligibilityBo.expirationDate1 != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.expirationDate1,
                "MM/dd/yyyy"
              )
            : null;
        this.employmentEligibilityBo.expirationDate2 =
          this.employmentEligibilityBo.expirationDate2 != null &&
          this.employmentEligibilityBo.expirationDate2 != undefined &&
          this.employmentEligibilityBo.expirationDate2 != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.expirationDate2,
                "MM/dd/yyyy"
              )
            : null;
        this.employmentEligibilityBo.expirationDate3 =
          this.employmentEligibilityBo.expirationDate3 != null &&
          this.employmentEligibilityBo.expirationDate3 != undefined &&
          this.employmentEligibilityBo.expirationDate3 != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.expirationDate3,
                "MM/dd/yyyy"
              )
            : null;
        this.employmentEligibilityBo.expirationDate4 =
          this.employmentEligibilityBo.expirationDate4 != null &&
          this.employmentEligibilityBo.expirationDate4 != undefined &&
          this.employmentEligibilityBo.expirationDate4 != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.expirationDate4,
                "MM/dd/yyyy"
              )
            : null;

        this.employmentEligibilityBo.employeesFirstdayEmployment =
          this.employmentEligibilityBo.employeesFirstdayEmployment != null &&
          this.employmentEligibilityBo.employeesFirstdayEmployment !=
            undefined &&
          this.employmentEligibilityBo.employeesFirstdayEmployment != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.employeesFirstdayEmployment,
                "MM/dd/yyyy"
              )
            : null;

        this.employmentEligibilityBo.employerSignDate1 =
          this.employmentEligibilityBo.employerSignDate1 != null &&
          this.employmentEligibilityBo.employerSignDate1 != undefined &&
          this.employmentEligibilityBo.employerSignDate1 != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.employerSignDate1,
                "MM/dd/yyyy"
              )
            : null;

            this.employmentEligibilityBo.employerSignDate3 =
            this.employmentEligibilityBo.employerSignDate3 != null &&
            this.employmentEligibilityBo.employerSignDate3 != undefined &&
            this.employmentEligibilityBo.employerSignDate3 != ""
              ? this.datepipe.transform(
                  this.employmentEligibilityBo.employerSignDate3,
                  "MM/dd/yyyy"
                )
              : null;    
        this.employmentEligibilityBo.reverificationDate =
          this.employmentEligibilityBo.reverificationDate != null &&
          this.employmentEligibilityBo.reverificationDate != undefined &&
          this.employmentEligibilityBo.reverificationDate != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.reverificationDate,
                "MM/dd/yyyy"
              )
            : null;

        this.employmentEligibilityBo.documentExpiryDate =
          this.employmentEligibilityBo.documentExpiryDate != null &&
          this.employmentEligibilityBo.documentExpiryDate != undefined &&
          this.employmentEligibilityBo.documentExpiryDate != ""
            ? this.datepipe.transform(
                this.employmentEligibilityBo.documentExpiryDate,
                "MM/dd/yyyy"
              )
            : null;
        this.individualSupportWorkerBo.signDate =
          this.individualSupportWorkerBo.signDate != null &&
          this.individualSupportWorkerBo.signDate != undefined &&
          this.individualSupportWorkerBo.signDate != ""
            ? this.datepipe.transform(
                this.individualSupportWorkerBo.signDate,
                "MM/dd/yyyy"
              )
            : null;

         this.individualDirectSupportBo.signDate =(
           this.individualDirectSupportBo.signDate != null &&
           this.individualDirectSupportBo.signDate != undefined &&
           this.individualDirectSupportBo.signDate != "")
             ? this.datepipe.transform(
                 this.individualDirectSupportBo.signDate, "MM/dd/yyyy" )

             : null;

        this.employeesWithholdingBo.signDate =
          this.employeesWithholdingBo.signDate != null &&
          this.employeesWithholdingBo.signDate != undefined &&
          this.employeesWithholdingBo.signDate != ""
            ? this.datepipe.transform(
                this.employeesWithholdingBo.signDate,
                "MM/dd/yyyy"
              )
            : null;

        this.employeesWithholdingBo.firstDateOfEmployeement =
          this.employeesWithholdingBo.firstDateOfEmployeement != null &&
          this.employeesWithholdingBo.firstDateOfEmployeement != undefined &&
          this.employeesWithholdingBo.firstDateOfEmployeement != ""
            ? this.datepipe.transform(
                this.employeesWithholdingBo.firstDateOfEmployeement,
                "MM/dd/yyyy"
              )
            : null;

        this.w4MinnesotaWithholdingBo.date =
          this.w4MinnesotaWithholdingBo.date != null &&
          this.w4MinnesotaWithholdingBo.date != undefined &&
          this.w4MinnesotaWithholdingBo.date != ""
            ? this.datepipe.transform(
                this.w4MinnesotaWithholdingBo.date,
                "MM/dd/yyyy"
              )
            : null;

       // this.prepopulatefun();
        this.prepopulateclientfun();
      });
  }

  getEmployeeDetails() {
    let params = new URLSearchParams();
    params.append("EmployeeId", this.emitemployeeBO.employeeid);
    if(this.global.OnboardingLoginType !='onboardLogin'){
    this.agreementService
      .getEmployeeBio(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if (data) {          
          this.prepopulatevalue = data;
          console.log("data------------",data)
          console.log("if ", this.prepopulatevalue);
          setTimeout(a=>{
            this.prepopulatefun();
          },500);
        }
      });
    }
    else{
      this.agreementService
      .getEmployeeBioPortal(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if(data) {
          console.log("data",data);
          //data=JSON.parse(data);
          this.emitemployeeBO.employeeid=data.id;
          console.log("else", this.prepopulatevalue)
          this.prepopulatevalue =data;
          setTimeout(a=>{
            this.prepopulatefun();
          },500);
        }
      
      })
    }
  }

  getclientDetails() {
    let params = new URLSearchParams();
    params.append("ClientId", this.emitemployeeBO.clientid);
    // if(this.global.OnboardingLoginType !='onboardLogin'){
    this.agreementService
      .getClientBio(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if (data) {
          this.prepopulateClientvalue = data;
         this.prepopulateclientfun();
        }
      });
    }
    // }else{
    //   this.agreementService
    //   .getClientBioPortal()
    //   .pipe(takeUntil(this.onDestroy$))
    //   .subscribe((data) => {
    //     console.log(data,'client portal');
    //     this.prepopulateClientvalue = data;
    //   })
    // }
  // }

  GetEmployeePayrateList() {
    let params = new URLSearchParams();
    params.append("EmployeeId", this.emitemployeeBO.employeeid);
    params.append("ClientId", this.emitemployeeBO.clientid);

    // this.getpayratelist.employeeId=this.emitemployeeBO.employeeid
    // this.getpayratelist.clientId=this.emitemployeeBO.clientid
    if(this.global.OnboardingLoginType !='onboardLogin'){
    this.agreementService
      .GetEmployeePayrate(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if (data) {
          this.payratelist = JSON.parse(data);      

         let obj =new  PayNoticePayrateDetailBO()



         if(this.payratelist!=undefined && this.payratelist!=null){
          this.payratelist.forEach((ele)=>{
           obj = new  PayNoticePayrateDetailBO()
           obj.rate= ele.rate;
           obj.effectiveDate=ele.startDate
           obj.service=ele.serviceName
           obj.payNoticeId=ele.id

this.PayNoticePayrateDetailBo.push(obj)

          })}
        }
      });
    }
    else{
      this.agreementService
      .GetEmployeePayratePortal()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.payratelist = JSON.parse(data);    
      }
      )
    }
  }

  reationshipname:any
  relationShipTaxName:any;
  GetEmployeeClientRelationshipList() {
    let params = new URLSearchParams();
    params.append("EmployeeId", this.emitemployeeBO.employeeid);
    params.append("ClientId", this.emitemployeeBO.clientid);
    if(this.global.OnboardingLoginType !='onboardLogin'){
    this.agreementService
      .GetEmployeeClientRelationshipData(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        if (data) {
          this.reationshipname=data.relationshipName
          this.relationshipBo.relationshipName=this.reationshipname
          this.relationshiplist = data.relationshipTaxes;
          this.relationShipTaxName = data.relationshipTaxes;
          this.relationShipTaxName.forEach((element) => {
           if(element.taxable == true ) {
            element.isTaxble = 'Taxable'
           }
           else{
            element.isTaxble = 'Exempt'
         
           }
          });
          // this.relationdisclosureBo=this.reationshiplist
let obj=new RelationshipDisclosureTaxDetailBO()
obj=this.relationshiplist
if(this.relationshiplist!=undefined && this.relationshiplist!=null){
this.relationshiplist.forEach((ele)=>{
  obj=new RelationshipDisclosureTaxDetailBO()

  obj.relationshipDisclosureId=data.relationshipId
  obj.taxName=ele.taxName
  obj.taxable=ele.taxable
  this.relationdisclosureBo.push(obj)
  
})        } 
        }
      });
  }else{
    this.agreementService
      .GetEmployeeClientRelationshipDataPortal()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
          this.relationshiplist = data.relationshipTaxes;
          this.relationShipTaxName = data.relationshipTaxes;
          this.emitemployeeBO.employeeid=data.employeeId;
          this.relationShipTaxName.forEach((element) => {
           if(element.taxable == true ) {
            element.taxable='Taxable';
           }
           else{
            element.taxable='Exempt';
           }
          });
          
       
          this.reationshipname=data.relationshipName
          this.relationshipBo.relationshipName=this.reationshipname

      })
  }
}

  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == "date1") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.dob = val1;
        }
      }
      if (name == "date2") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previousNamesUsedDate1 = val1;
        }
      }
      if (name == "date3") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previousNamesUsedDate2 = val1;
        }
      }
      if (name == "date4") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate1 = val1;
        }
      }
      if (name == "date5") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate2 = val1;
        }
      }
      if (name == "date6") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate3 = val1;
        }
      }
      if (name == "date7") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.applicantSignatureDate = val1;
        }
      }
      if (name == "date8") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.parentSignatureDate = val1;
        }
      }
      if (name == "date9") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.payNoticeBo.employeeSignDate = val1;
        }
      }
      if (name == "date10") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.payNoticeBo.employerSignDate = val1;
        }
      }
      if (name == "date11") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.relationshipBo.dob = val1;
        }
      }
      if (name == "date12") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.relationshipBo.applicantSignDate = val1;
        }
      }
      if (name == "date13") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.relationshipBo.employersSignDate = val1;
        }
      }
      if (name == "date14") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.previousEmployementEndDate = val1;
        }
      }
      if (name == "date15") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.dob = val1;
        }
      }
      if (name == "date16") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.optionalTrainingCompletionDate = val1;
        }
      }
      if (name == "date17") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.optionalTrainingExpirationDate = val1;
        }
      }
      if (name == "date18") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.dob = val1;
        }
      }
      if (name == "date19") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.alien_Registration_ExpiryDate = val1;
        }
      }
      if (name == "date20") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.todaysDate = val1;
        }
      }
      if (name == "date21") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.signOfPreparerorTraslatorDate = val1;
        }
      }
      if (name == "date22") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate = val1;
        }
      }
      if (name == "date23") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate1 = val1;
        }
      }

      if (name == "date24") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate2 = val1;
        }
      }
      if (name == "date25") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate3 = val1;
        }
      }
      if (name == "date26") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.expirationDate4 = val1;
        }
      }
      if (name == "date27") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.employeesFirstdayEmployment = val1;
        }
      }
      if (name == "date28") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.employerSignDate1 = val1;
        }
      }
      if (name == "date29") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.reverificationDate = val1;
        }
      }
      if (name == "date30") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.documentExpiryDate = val1;
        }
      }
      if (name == "date31") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employmentEligibilityBo.employerSignDate3 = val1;
        }
      }
      if (name == "date32") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employeesWithholdingBo.signDate = val1;
        }
      }
      if (name == "date33") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.employeesWithholdingBo.firstDateOfEmployeement = val1;
        }
      }
      if (name == "date34") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.w4MinnesotaWithholdingBo.date = val1;
        }
      }
      if (name == "date35") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualSupportWorkerBo.signDate = val1;
        }
      }
      if (name == "date36") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.individualDirectSupportBo.signDate = val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "date1") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.dob = val1;
        }
      }
      if (name == "date2") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previousNamesUsedDate1 = val1;
        }
      }
      if (name == "date3") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previousNamesUsedDate2 = val1;
        }
      }

      if (name == "date4") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate1 = val1;
        }
      }
      if (name == "date5") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate2 = val1;
        }
      }
      if (name == "date6") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate3 = val1;
        }
      }
      if (name == "date7") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.applicantSignatureDate = val1;
        }
      }
      if (name == "date8") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.parentSignatureDate = val1;
        }
      }
      if (name == "date9") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.payNoticeBo.employeeSignDate = val1;
        }
      }
      if (name == "date10") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.payNoticeBo.employerSignDate = val1;
        }
      }
      if (name == "date11") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.relationshipBo.dob = val1;
        }
      }
      if (name == "date12") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.relationshipBo.applicantSignDate = val1;
        }
      }
      if (name == "date13") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.relationshipBo.employersSignDate = val1;
        }
      }
      if (name == "date14") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.previousEmployementEndDate = val1;
        }
      }
      if (name == "date15") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.dob = val1;
        }
      }
      if (name == "date16") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.optionalTrainingCompletionDate = val1;
        }
      }
      if (name == "date17") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.optionalTrainingExpirationDate = val1;
        }
      }
      if (name == "date18") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.dob = val1;
        }
      }
      if (name == "date19") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.alien_Registration_ExpiryDate = val1;
        }
      }
      if (name == "date20") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.todaysDate = val1;
        }
      }
      if (name == "date21") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.signOfPreparerorTraslatorDate = val1;
        }
      }
      if (name == "date22") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate = val1;
        }
      }
      if (name == "date23") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate1 = val1;
        }
      }
      if (name == "date24") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate2 = val1;
        }
      }
      if (name == "date25") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate3 = val1;
        }
      }
      if (name == "date26") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.expirationDate4 = val1;
        }
      }
      if (name == "date27") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.employeesFirstdayEmployment = val1;
        }
      }
      if (name == "date28") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.employerSignDate1 = val1;
        }
      }
      if (name == "date29") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.employmentEligibilityBo.reverificationDate = val1;
        }
      }
    }
    if (name == "date30") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.employmentEligibilityBo.documentExpiryDate = val1;
      }
    }

    if (name == "date31") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.employmentEligibilityBo.employerSignDate3 = val1;
      }
    }

    if (name == "date32") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.employeesWithholdingBo.signDate = val1;
      }
    }
    if (name == "date33") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.employeesWithholdingBo.firstDateOfEmployeement = val1;
      }
    }
    if (name == "date34") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.w4MinnesotaWithholdingBo.date = val1;
      }
    }
      if (name == "date35") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualSupportWorkerBo.signDate = val1;
        }
      }
      if (name == "date36") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.individualDirectSupportBo.signDate = val1;
        }
      }
  }

  DemographicPhoneFormat() {
    this.w4MinnesotaWithholdingBo.phoneNumber =
      this.general.converPhoneGoogleLib(
        this.w4MinnesotaWithholdingBo.phoneNumber
      );
    this.employmentEligibilityBo.employeesPhone =
      this.general.converPhoneGoogleLib(
        this.employmentEligibilityBo.employeesPhone
      );
    this.individualDirectSupportBo.orgPersonalFax =
      this.general.converPhoneGoogleLib(
        this.individualDirectSupportBo.orgPersonalFax
      );
    this.individualDirectSupportBo.phone = this.general.converPhoneGoogleLib(
      this.individualDirectSupportBo.phone
    );  
    this.backgroundBo.phone = this.general.converPhoneGoogleLib(
      this.backgroundBo.phone
    );
  }

  genderlist: any;
  getGenderList() {
    let params = new URLSearchParams();
    params.append("ListCode", "GENDER");
    this.employeeService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.genderlist = data;
      });
  }
  employerList: any;
  getEmployerType() {
    let params = new URLSearchParams();
    params.append("ListCode", "EMPLOYERTITLE");
    this.employeeService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.employerList = data;
      });
  }

  prepopulateclientfun() {
if(this.prepopulateClientvalue){
    this.backgroundBo.participantName = this.backgroundBo.participantName != null && this.backgroundBo.participantName != undefined && this.backgroundBo.participantName != "" ? this.backgroundBo.participantName : this.prepopulateClientvalue.name;
    this.employmentEligibilityBo.employerFirstName= this.employmentEligibilityBo.employerFirstName != null && this.employmentEligibilityBo.employerFirstName != undefined && this.employmentEligibilityBo.employerFirstName != "" ? this.employmentEligibilityBo.employerFirstName : this.prepopulateClientvalue.firstName
    this.employmentEligibilityBo.employerLastName = this.employmentEligibilityBo.employerLastName != null && this.employmentEligibilityBo.employerLastName != undefined && this.employmentEligibilityBo.employerLastName != "" ? this.employmentEligibilityBo.employerLastName : this.prepopulateClientvalue.lastName;
    this.employmentEligibilityBo.employersAddress = this.employmentEligibilityBo.employersAddress != null && this.employmentEligibilityBo.employersAddress != undefined && this.employmentEligibilityBo.employersAddress != "" ? this.employmentEligibilityBo.employersAddress : this.prepopulateClientvalue.street;
    this.employmentEligibilityBo.employersCity = this.employmentEligibilityBo.employersCity != null && this.employmentEligibilityBo.employersCity != undefined && this.employmentEligibilityBo.employersCity != "" ? this.employmentEligibilityBo.employersCity : this.prepopulateClientvalue.city;
    this.employmentEligibilityBo.employersState = this.employmentEligibilityBo.employersState != null && this.employmentEligibilityBo.employersState != undefined && this.employmentEligibilityBo.employersState != "" ? this.employmentEligibilityBo.employersState : this.prepopulateClientvalue.state;
    // this.employmentEligibilityBo.preparerZip = this.prepopulateClientvalue.zipCode;
    this.w4MinnesotaWithholdingBo.nameofEmployer = this.w4MinnesotaWithholdingBo.nameofEmployer != null && this.w4MinnesotaWithholdingBo.nameofEmployer != undefined && this.w4MinnesotaWithholdingBo.nameofEmployer != "" ? this.w4MinnesotaWithholdingBo.nameofEmployer : this.prepopulateClientvalue.name;
    this.w4MinnesotaWithholdingBo.employerAddress = this.w4MinnesotaWithholdingBo.employerAddress != null && this.w4MinnesotaWithholdingBo.employerAddress != undefined && this.w4MinnesotaWithholdingBo.employerAddress != "" ? this.w4MinnesotaWithholdingBo.employerAddress : this.prepopulateClientvalue.street;
    this.w4MinnesotaWithholdingBo.employerCity = this.w4MinnesotaWithholdingBo.employerCity != null && this.w4MinnesotaWithholdingBo.employerCity != undefined && this.w4MinnesotaWithholdingBo.employerCity != "" ? this.w4MinnesotaWithholdingBo.employerCity : this.prepopulateClientvalue.city;
    this.w4MinnesotaWithholdingBo.employerState = this.w4MinnesotaWithholdingBo.employerState != null && this.w4MinnesotaWithholdingBo.employerState != undefined && this.w4MinnesotaWithholdingBo.employerState != "" ? this.w4MinnesotaWithholdingBo.employerState : this.prepopulateClientvalue.state;
    this.w4MinnesotaWithholdingBo.employerZip = this.w4MinnesotaWithholdingBo.employerZip != null && this.w4MinnesotaWithholdingBo.employerZip != undefined && this.w4MinnesotaWithholdingBo.employerZip != "" ? this.w4MinnesotaWithholdingBo.employerZip : this.prepopulateClientvalue.zipCode;
  //this.w4MinnesotaWithholdingBo.phoneNumber = this.prepopulateClientvalue.phoneNumber;

  
    this.payNoticeBo.employerName = this.payNoticeBo.employerName != null && this.payNoticeBo.employerName != undefined && this.payNoticeBo.employerName != "" ? this.payNoticeBo.employerName : this.prepopulateClientvalue.name;
    this.relationshipBo.employerName = this.relationshipBo.employerName != null && this.relationshipBo.employerName != undefined && this.relationshipBo.employerName != "" ? this.relationshipBo.employerName : this.prepopulateClientvalue.name;
  }
}
  prepopulatefun() {
    if(this.prepopulatevalue!=null&&this.prepopulatevalue!=undefined&&this.prepopulatevalue!=''){
      let db =(this.prepopulatevalue.dob != null &&
        this.prepopulatevalue.dob != undefined &&
        this.prepopulatevalue.dob != "")
          ? this.datepipe.transform(this.prepopulatevalue.dob, "MM/dd/yyyy")
          : null;
      this.backgroundBo.dob = this.backgroundBo.dob != null && this.backgroundBo.dob != undefined && this.backgroundBo.dob != "" ? this.backgroundBo.dob : db;
      this.employmentEligibilityBo.dob = this.employmentEligibilityBo.dob != null && this.employmentEligibilityBo.dob != undefined && this.employmentEligibilityBo.dob != "" ? this.employmentEligibilityBo.dob : db;
      this.individualDirectSupportBo.dob = this.individualDirectSupportBo.dob != null && this.individualDirectSupportBo.dob != undefined && this.individualDirectSupportBo.dob != "" ? this.individualDirectSupportBo.dob : db;
      this.relationshipBo.dob = this.relationshipBo.dob != null && this.relationshipBo.dob != undefined && this.relationshipBo.dob != "" ? this.relationshipBo.dob : db;

  
    }
  
    this.employeeApplicationBo.employeeName = this.employeeApplicationBo.employeeName != null && this.employeeApplicationBo.employeeName != undefined && this.employeeApplicationBo.employeeName != "" ? this.employeeApplicationBo.employeeName : this.prepopulatevalue.name;

    this.backgroundBo.firstName = this.backgroundBo.firstName != null && this.backgroundBo.firstName != undefined && this.backgroundBo.firstName != "" ? this.backgroundBo.firstName : this.prepopulatevalue.firstName;
    this.backgroundBo.middleName =  this.backgroundBo.middleName != null &&  this.backgroundBo.middleName != undefined &&  this.backgroundBo.middleName != "" ?  this.backgroundBo.middleName : this.prepopulatevalue.middleName;
    this.backgroundBo.lastName = this.backgroundBo.lastName != null && this.backgroundBo.lastName != undefined && this.backgroundBo.lastName != "" ? this.backgroundBo.lastName : this.prepopulatevalue.lastName;
    this.backgroundBo.ssn = this.backgroundBo.ssn != null && this.backgroundBo.ssn != undefined && this.backgroundBo.ssn !=  "" ? this.backgroundBo.ssn : this.prepopulatevalue.ssn;
    this.backgroundBo.state = this.backgroundBo.state != null && this.backgroundBo.state != undefined && this.backgroundBo.state != "" ? this.backgroundBo.state : this.prepopulatevalue.steet;
    this.backgroundBo.phone = this.backgroundBo.phone != null && this.backgroundBo.phone != undefined && this.backgroundBo.phone != "" ? this.backgroundBo.phone :  this.prepopulatevalue.phone1;
    this.backgroundBo.state1 = this.backgroundBo.state1 != null && this.backgroundBo.state1 != undefined && this.backgroundBo.state1 != "" ? this.backgroundBo.state1 : this.prepopulatevalue.steet;
    this.backgroundBo.email = this.backgroundBo.email != null && this.backgroundBo.email != undefined && this.backgroundBo.email != "" ? this.backgroundBo.email : this.prepopulatevalue.email;
    this.backgroundBo.driver_LicenseNo = this.backgroundBo.driver_LicenseNo != null && this.backgroundBo.driver_LicenseNo != undefined && this.backgroundBo.driver_LicenseNo != "" ? this.backgroundBo.driver_LicenseNo : this.prepopulatevalue.driverLicense;
    this.backgroundBo.placeofBirth = this.backgroundBo.placeofBirth != null && this.backgroundBo.placeofBirth != undefined && this.backgroundBo.placeofBirth != "" ? this.backgroundBo.placeofBirth : this.prepopulatevalue.placeofBirth;
    this.backgroundBo.genderLid = this.backgroundBo.genderLid != null && this.backgroundBo.genderLid != undefined && this.backgroundBo.genderLid != "" ? this.backgroundBo.genderLid : this.prepopulatevalue.genderLid;

    this.payNoticeBo.employeeName = this.payNoticeBo.employeeName != null && this.payNoticeBo.employeeName != undefined && this.payNoticeBo.employeeName != "" ? this.payNoticeBo.employeeName : this.prepopulatevalue.name;


    this.relationshipBo.employeeName = this.relationshipBo.employeeName != null && this.relationshipBo.employeeName  != undefined && this.relationshipBo.employeeName != "" ? this.relationshipBo.employeeName : this.prepopulatevalue.name;

    this.individualDirectSupportBo.street = this.individualDirectSupportBo.street != null && this.individualDirectSupportBo.street != undefined && this.individualDirectSupportBo.street != "" ? this.individualDirectSupportBo.street : this.prepopulatevalue.street ;
    this.individualDirectSupportBo.nameIndividualSupportWorker = this.individualDirectSupportBo.nameIndividualSupportWorker != null && this.individualDirectSupportBo.nameIndividualSupportWorker != undefined && this.individualDirectSupportBo.nameIndividualSupportWorker != "" ? this.individualDirectSupportBo.nameIndividualSupportWorker : this.prepopulatevalue.name;

    this.employmentEligibilityBo.reverificationFirstName = this.employmentEligibilityBo.reverificationFirstName != null && this.employmentEligibilityBo.reverificationFirstName != undefined && this.employmentEligibilityBo.reverificationFirstName != "" ? this.employmentEligibilityBo.reverificationFirstName : this.prepopulatevalue.firstName;
    this.employmentEligibilityBo.reverificationLastName = this.employmentEligibilityBo.reverificationLastName != null && this.employmentEligibilityBo.reverificationLastName != undefined && this.employmentEligibilityBo.reverificationLastName != "" ? this.employmentEligibilityBo.reverificationLastName :  this.prepopulatevalue.lastName;
    this.employmentEligibilityBo.reverificationMiddleName = this.employmentEligibilityBo.reverificationMiddleName != null && this.employmentEligibilityBo.reverificationMiddleName != undefined && this.employmentEligibilityBo.reverificationMiddleName != "" ? this.employmentEligibilityBo.reverificationMiddleName :  this.prepopulatevalue.middleName;
    this.employmentEligibilityBo.firstName = this.employmentEligibilityBo.firstName != null && this.employmentEligibilityBo.firstName != undefined && this.employmentEligibilityBo.firstName != "" ? this.employmentEligibilityBo.firstName :  this.prepopulatevalue.firstName;
    this.employmentEligibilityBo.lastName = this.employmentEligibilityBo.lastName != null && this.employmentEligibilityBo.lastName != undefined && this.employmentEligibilityBo.lastName != "" ? this.employmentEligibilityBo.lastName :  this.prepopulatevalue.lastName;
    this.employmentEligibilityBo.middleName = this.employmentEligibilityBo.middleName != null && this.employmentEligibilityBo.middleName != undefined && this.employmentEligibilityBo.middleName != "" ? this.employmentEligibilityBo.middleName :  this.prepopulatevalue.middleName;
    

    this.employmentEligibilityBo.us_Ssn = this.employmentEligibilityBo.us_Ssn != null && this.employmentEligibilityBo.us_Ssn != undefined && this.employmentEligibilityBo.us_Ssn != "" ? this.employmentEligibilityBo.us_Ssn : this.prepopulatevalue.ssn;
    this.employmentEligibilityBo.employees_Email = this.employmentEligibilityBo.employees_Email != null && this.employmentEligibilityBo.employees_Email != undefined && this.employmentEligibilityBo.employees_Email != "" ? this.employmentEligibilityBo.employees_Email : this.prepopulatevalue.email;
    this.employmentEligibilityBo.employeesPhone = this.employmentEligibilityBo.employeesPhone != null && this.employmentEligibilityBo.employeesPhone != undefined && this.employmentEligibilityBo.employeesPhone != "" ? this.employmentEligibilityBo.employeesPhone : this.prepopulatevalue.phone1;
    this.employmentEligibilityBo.employeeSection2LastName = this.employmentEligibilityBo.employeeSection2LastName != null && this.employmentEligibilityBo.employeeSection2LastName != undefined && this.employmentEligibilityBo.employeeSection2LastName != "" ? this.employmentEligibilityBo.employeeSection2LastName : this.prepopulatevalue.lastName;
    this.employmentEligibilityBo.employeeSection2FirstName = this.employmentEligibilityBo.employeeSection2FirstName != null && this.employmentEligibilityBo.employeeSection2FirstName != undefined && this.employmentEligibilityBo.employeeSection2FirstName != "" ? this.employmentEligibilityBo.employeeSection2FirstName : this.prepopulatevalue.firstName;
    this.employmentEligibilityBo.employeeSection2MiddleName = this.employmentEligibilityBo.employeeSection2MiddleName != null && this.employmentEligibilityBo.employeeSection2MiddleName != undefined && this.employmentEligibilityBo.employeeSection2MiddleName != "" ? this.employmentEligibilityBo.employeeSection2MiddleName : this.prepopulatevalue.middleName;

    this.employeesWithholdingBo.firstName = this.employeesWithholdingBo.firstName != null && this.employeesWithholdingBo.firstName != undefined && this.employeesWithholdingBo.firstName!= "" ? this.employeesWithholdingBo.firstName : this.prepopulatevalue.firstName;
    this.employeesWithholdingBo.lastName = this.employeesWithholdingBo.lastName != null && this.employeesWithholdingBo.lastName != undefined && this.employeesWithholdingBo.lastName!= "" ? this.employeesWithholdingBo.lastName :  this.prepopulatevalue.lastName;
    this.employeesWithholdingBo.middleName = this.employeesWithholdingBo.middleName != null && this.employeesWithholdingBo.middleName != undefined && this.employeesWithholdingBo.middleName!= "" ? this.employeesWithholdingBo.middleName :  this.prepopulatevalue.middleName;
    this.employeesWithholdingBo.social_Security_Number = this.employeesWithholdingBo.social_Security_Number != null && this.employeesWithholdingBo.social_Security_Number != undefined && this.employeesWithholdingBo.social_Security_Number!= "" ? this.employeesWithholdingBo.social_Security_Number :  this.prepopulatevalue.ssn;
    this.employeesWithholdingBo.employeeName = this.employeesWithholdingBo.employeeName != null && this.employeesWithholdingBo.employeeName != undefined && this.employeesWithholdingBo.employeeName!= "" ? this.employeesWithholdingBo.employeeName :  this.prepopulatevalue.name;
    this.employeesWithholdingBo.address = this.employeesWithholdingBo.address != null && this.employeesWithholdingBo.address != undefined && this.employeesWithholdingBo.address!= "" ? this.employeesWithholdingBo.address :  this.prepopulatevalue.street;
    this.employeesWithholdingBo.state = this.employeesWithholdingBo.state != null && this.employeesWithholdingBo.state != undefined && this.employeesWithholdingBo.state!= "" ? this.employeesWithholdingBo.state :  this.prepopulatevalue.steet;
   // this.employeesWithholdingBo.maritialStatus = this.prepopulatevalue.maritialStatus;
    
    this.w4MinnesotaWithholdingBo.firstName  = this.w4MinnesotaWithholdingBo.firstName != null && this.w4MinnesotaWithholdingBo.firstName != undefined && this.w4MinnesotaWithholdingBo.firstName != "" ? this.w4MinnesotaWithholdingBo.firstName : this.prepopulatevalue.firstName + (( this.prepopulatevalue.middleName != null && this.prepopulatevalue.middleName != undefined ) ? this.prepopulatevalue.middleName : '' );
    this.w4MinnesotaWithholdingBo.lastName = this.w4MinnesotaWithholdingBo.lastName != null && this.w4MinnesotaWithholdingBo.lastName != undefined && this.w4MinnesotaWithholdingBo.lastName != "" ? this.w4MinnesotaWithholdingBo.lastName : this.prepopulatevalue.lastName;
    this.w4MinnesotaWithholdingBo.middleInitial = this.w4MinnesotaWithholdingBo.middleInitial != null && this.w4MinnesotaWithholdingBo.middleInitial != undefined && this.w4MinnesotaWithholdingBo.middleInitial != "" ? this.w4MinnesotaWithholdingBo.middleInitial : this.prepopulatevalue.middleName;
    this.w4MinnesotaWithholdingBo.socialSecurityNumber = this.w4MinnesotaWithholdingBo.socialSecurityNumber != null && this.w4MinnesotaWithholdingBo.socialSecurityNumber != undefined && this.w4MinnesotaWithholdingBo.socialSecurityNumber != "" ? this.w4MinnesotaWithholdingBo.socialSecurityNumber : this.prepopulatevalue.ssn;
    this.w4MinnesotaWithholdingBo.state = this.w4MinnesotaWithholdingBo.state != null && this.w4MinnesotaWithholdingBo.state != undefined && this.w4MinnesotaWithholdingBo.state != "" ? this.w4MinnesotaWithholdingBo.state : this.prepopulatevalue.steet;
    //this.w4MinnesotaWithholdingBo.phoneNumber = this.prepopulatevalue.phoneNumber;
    this.backgroundBo.zip = this.backgroundBo.zip != null && this.backgroundBo.zip != undefined && this.backgroundBo.zip != "" ? this.backgroundBo.zip : this.prepopulatevalue.zipcode;
    this.backgroundBo.address = this.backgroundBo.address != null && this.backgroundBo.address != undefined && this.backgroundBo.address != "" ? this.backgroundBo.address : this.prepopulatevalue.street;
    this.backgroundBo.city = this.backgroundBo.city != null && this.backgroundBo.city != undefined && this.backgroundBo.city != "" ? this.backgroundBo.city : this.prepopulatevalue.city;
    this.backgroundBo.county = this.backgroundBo.county != null && this.backgroundBo.county != undefined && this.backgroundBo.county != "" ? this.backgroundBo.county : this.prepopulatevalue.county;

    this.employmentEligibilityBo.address = this.employmentEligibilityBo.address != null && this.employmentEligibilityBo.address != undefined && this.employmentEligibilityBo.address != "" ? this.employmentEligibilityBo.address : this.prepopulatevalue.street;
    this.employmentEligibilityBo.apt = this.employmentEligibilityBo.apt != null && this.employmentEligibilityBo.apt != undefined && this.employmentEligibilityBo.apt != "" ? this.employmentEligibilityBo.apt : this.prepopulatevalue.apt;
    this.employmentEligibilityBo.city = this.employmentEligibilityBo.city != null && this.employmentEligibilityBo.city != undefined && this.employmentEligibilityBo.city != "" ? this.employmentEligibilityBo.city : this.prepopulatevalue.city;
    this.employmentEligibilityBo.state = this.employmentEligibilityBo.state != null && this.employmentEligibilityBo.state != undefined && this.employmentEligibilityBo.state != "" ? this.employmentEligibilityBo.state : this.prepopulatevalue.steet;
    // this.employmentEligibilityBo.zip = this.prepopulatevalue.zipcode;

    this.employeesWithholdingBo.city = this.employeesWithholdingBo.city != null && this.employeesWithholdingBo.city != undefined && this.employeesWithholdingBo.city!= "" ? this.employeesWithholdingBo.city : this.prepopulatevalue.city;
    this.employeesWithholdingBo.zip = this.employeesWithholdingBo.zip != null && this.employeesWithholdingBo.zip != undefined && this.employeesWithholdingBo.zip!= "" ? this.employeesWithholdingBo.zip : this.prepopulatevalue.zipcode;

    this.w4MinnesotaWithholdingBo.address = this.w4MinnesotaWithholdingBo.address != null && this.w4MinnesotaWithholdingBo.address != undefined && this.w4MinnesotaWithholdingBo.address != "" ? this.w4MinnesotaWithholdingBo.address : this.prepopulatevalue.street;
    this.w4MinnesotaWithholdingBo.city = this.w4MinnesotaWithholdingBo.city != null && this.w4MinnesotaWithholdingBo.city != undefined && this.w4MinnesotaWithholdingBo.city != "" ? this.w4MinnesotaWithholdingBo.city : this.prepopulatevalue.city;
    this.w4MinnesotaWithholdingBo.zip = this.w4MinnesotaWithholdingBo.zip != null && this.w4MinnesotaWithholdingBo.zip != undefined && this.w4MinnesotaWithholdingBo.zip != "" ? this.w4MinnesotaWithholdingBo.zip : this.prepopulatevalue.zipcode;

    this.individualSupportWorkerBo.umpi = this.individualSupportWorkerBo.umpi != null && this.individualSupportWorkerBo.umpi != undefined && this.individualSupportWorkerBo.umpi != "" ? this.individualSupportWorkerBo.umpi : this.prepopulatevalue.umpi;
    this.individualSupportWorkerBo.nameofSupportWorkerName =
    this.individualSupportWorkerBo.nameofSupportWorkerName != null && this.individualSupportWorkerBo.nameofSupportWorkerName != undefined && this.individualSupportWorkerBo.nameofSupportWorkerName != "" ? this.individualSupportWorkerBo.nameofSupportWorkerName : this.prepopulatevalue.name;
    this.individualSupportWorkerBo.nameofSupportWorkerNamePrint =
    this.individualSupportWorkerBo.nameofSupportWorkerNamePrint != null && this.individualSupportWorkerBo.nameofSupportWorkerNamePrint != undefined && this.individualSupportWorkerBo.nameofSupportWorkerNamePrint != "" ? this.individualSupportWorkerBo.nameofSupportWorkerNamePrint : this.prepopulatevalue.name;

    this.individualDirectSupportBo.ssn = this.individualDirectSupportBo.ssn != null && this.individualDirectSupportBo.ssn != undefined && this.individualDirectSupportBo.ssn != "" ? this.individualDirectSupportBo.ssn : this.prepopulatevalue.ssn;
    this.individualDirectSupportBo.npiOrUmpi = this.individualDirectSupportBo.npiOrUmpi != null && this.individualDirectSupportBo.npiOrUmpi != undefined && this.individualDirectSupportBo.npiOrUmpi != "" ? this.individualDirectSupportBo.npiOrUmpi : this.prepopulatevalue.umpi;
    this.individualDirectSupportBo.firstName = this.individualDirectSupportBo.firstName != null && this.individualDirectSupportBo.firstName != undefined && this.individualDirectSupportBo.firstName != "" ? this.individualDirectSupportBo.firstName : this.prepopulatevalue.firstName;
    this.individualDirectSupportBo.lastName = this.individualDirectSupportBo.lastName != null && this.individualDirectSupportBo.lastName != undefined && this.individualDirectSupportBo.lastName != "" ? this.individualDirectSupportBo.lastName : this.prepopulatevalue.lastName;
    this.individualDirectSupportBo.middleName != null && this.individualDirectSupportBo.middleName != undefined && this.individualDirectSupportBo.middleName != "" ? this.individualDirectSupportBo.middleName : this.prepopulatevalue.middleName;
    this.individualDirectSupportBo.phone = this.individualDirectSupportBo.phone != null && this.individualDirectSupportBo.phone != undefined && this.individualDirectSupportBo.phone != "" ? this.individualDirectSupportBo.phone : this.prepopulatevalue.phone1;
    this.individualDirectSupportBo.county = this.individualDirectSupportBo.county != null && this.individualDirectSupportBo.county != undefined && this.individualDirectSupportBo.county != "" ? this.individualDirectSupportBo.county : this.prepopulatevalue.county;
    this.individualDirectSupportBo.zip = this.individualDirectSupportBo.zip != null && this.individualDirectSupportBo.zip != undefined && this.individualDirectSupportBo.zip != "" ? this.individualDirectSupportBo.zip : this.prepopulatevalue.zipcode;
    this.individualDirectSupportBo.state = this.individualDirectSupportBo.state != null && this.individualDirectSupportBo.state != undefined && this.individualDirectSupportBo.state != "" ? this.individualDirectSupportBo.state : this.prepopulatevalue.steet;
    this.individualDirectSupportBo.city = this.individualDirectSupportBo.city != null && this.individualDirectSupportBo.city != undefined && this.individualDirectSupportBo.city != "" ? this.individualDirectSupportBo.city : this.prepopulatevalue.city;
  }
  getTemplateDetails() {
    let params = new URLSearchParams();
    
    params.append("TempleteId", this.emitemployeeBO.templateId);
    params.append("EmployeeId",this.emitemployeeBO.employeeid);
if(this.emitemployeeBO.templateId!=null&&this.emitemployeeBO.templateId!=undefined){
  this.employeeTemplateservice
  .getEmployeeTemplate(params)
  .pipe(takeUntil(this.onDestroy$))
  .subscribe((data) => {
    this.backgroundBo = data.backgroundStudyAuthorizationTemplate;
    this.employeeAgreementBo =
      data.employeeAgreementAndDirectDepositTemplate;
    this.employeeApplicationBo = data.employeeApplicationCoverTemplate;
    this.employeesWithholdingBo =
      data.employeesWithholdingCertificateTemplate;
    this.employmentEligibilityBo =
      data.employmentEligibilityVerificationTemplate;
    this.individualDirectSupportBo =
      data.individualDirectSupportWorkerEnrollmentApplicationTemplate;
    this.individualSupportWorkerBo =
      data.individualSupportWorkerProviderAgreementTemplate;
    this.relationshipBo = data.payNoticeTemplate;
    this.relationshipBo = data.relationshipDisclosureTemplate;
    this.w4MNInstructionsBo =
      data.w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplate;
    this.w4MinnesotaWithholdingBo =
      data.w4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplate;
      this.individualDirectSupportBoRadio1 = 
    this.appsign1 = this.backgroundBo.applicantSignature;
    this.sign4 = this.backgroundBo.parentSignature;
    this.individualDirectSupportBo.newHireOrReHire = data.individualDirectSupportWorkerEnrollmentApplicationTemplate.newHireOrReHire;
     this.individualDirectSupportBoRadio1= JSON.stringify(data.individualDirectSupportWorkerEnrollmentApplicationTemplate.isMcoClaimsOnly);
     this.individualDirectSupportBoRadio2 = JSON.stringify(data.individualDirectSupportWorkerEnrollmentApplicationTemplate.isQualifiedEnhancedRateTraining);
     this.individualDirectSupportBoRadio3 = JSON.stringify(data.individualDirectSupportWorkerEnrollmentApplicationTemplate.isAffiliateIndividualDsw)
         this.Gurdsign3 = this.payNoticeBo.employeeSign;
    this.employeesign2 = this.payNoticeBo.employerSign;

    this.clientsign0 = this.relationshipBo.employersSign;
    this.employeesign3 = this.relationshipBo.applicantSign;
    this.clientsign2 = this.employeeAgreementBo.employee_sign;

    this.individualsign = this.individualDirectSupportBo.sign;

    this.repsign = this.individualSupportWorkerBo.sign;

    this.employeesign = this.employmentEligibilityBo.signOfEmployee;
    this.translatorsign = this.employmentEligibilityBo.employerSign;
    this.authorizedsign = this.employmentEligibilityBo.employerSign1;
    this.authorizedrepsign =
      this.employmentEligibilityBo.signOfPreparerorTraslator;

    this.Gurdsign = this.employeesWithholdingBo.employeeSignature;
    this.clientsign1 = this.w4MinnesotaWithholdingBo.signature;
    this.backgroundBo.dob =
      this.backgroundBo.dob != null &&
      this.backgroundBo.dob != undefined &&
      this.backgroundBo.dob != ""
        ? this.datepipe.transform(this.backgroundBo.dob, "MM/dd/yyyy")
        : null;
    this.backgroundBo.previousNamesUsedDate1 =
      this.backgroundBo.previousNamesUsedDate1 != null &&
      this.backgroundBo.previousNamesUsedDate1 != undefined &&
      this.backgroundBo.previousNamesUsedDate1 != ""
        ? this.datepipe.transform(
            this.backgroundBo.previousNamesUsedDate1,
            "MM/dd/yyyy"
          )
        : null;
    this.backgroundBo.previousNamesUsedDate2 =
      this.backgroundBo.previousNamesUsedDate2 != null &&
      this.backgroundBo.previousNamesUsedDate2 != undefined &&
      this.backgroundBo.previousNamesUsedDate2 != ""
        ? this.datepipe.transform(
            this.backgroundBo.previousNamesUsedDate2,
            "MM/dd/yyyy"
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate1 =
      this.backgroundBo.previous_Addresses_UsedDate1 != null &&
      this.backgroundBo.previous_Addresses_UsedDate1 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate1 != ""
        ? this.datepipe.transform(
            this.backgroundBo.previous_Addresses_UsedDate1,
            "MM/dd/yyyy"
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate2 =
      this.backgroundBo.previous_Addresses_UsedDate2 != null &&
      this.backgroundBo.previous_Addresses_UsedDate2 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate2 != ""
        ? this.datepipe.transform(
            this.backgroundBo.previous_Addresses_UsedDate2,
            "MM/dd/yyyy"
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate3 =
      this.backgroundBo.previous_Addresses_UsedDate3 != null &&
      this.backgroundBo.previous_Addresses_UsedDate3 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate3 != ""
        ? this.datepipe.transform(
            this.backgroundBo.previous_Addresses_UsedDate3,
            "MM/dd/yyyy"
          )
        : null;

    this.backgroundBo.applicantSignatureDate =
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != ""
        ? this.datepipe.transform(
            this.backgroundBo.applicantSignatureDate,
            "MM/dd/yyyy"
          )
        : null;
    this.backgroundBo.parentSignatureDate =
      this.backgroundBo.parentSignatureDate != null &&
      this.backgroundBo.parentSignatureDate != undefined &&
      this.backgroundBo.parentSignatureDate != ""
        ? this.datepipe.transform(
            this.backgroundBo.parentSignatureDate,
            "MM/dd/yyyy"
          )
        : null;
    this.payNoticeBo.employeeSignDate =
      this.payNoticeBo.employeeSignDate != null &&
      this.payNoticeBo.employeeSignDate != undefined &&
      this.payNoticeBo.employeeSignDate != ""
        ? this.datepipe.transform(
            this.payNoticeBo.employeeSignDate,
            "MM/dd/yyyy"
          )
        : null;
    this.payNoticeBo.employerSignDate =
      this.payNoticeBo.employerSignDate != null &&
      this.payNoticeBo.employerSignDate != undefined &&
      this.payNoticeBo.employerSignDate != ""
        ? this.datepipe.transform(
            this.payNoticeBo.employerSignDate,
            "MM/dd/yyyy"
          )
        : null;

    this.relationshipBo.dob =
      this.relationshipBo.dob != null &&
      this.relationshipBo.dob != undefined &&
      this.relationshipBo.dob != ""
        ? this.datepipe.transform(this.relationshipBo.dob, "MM/dd/yyyy")
        : null;
    this.relationshipBo.applicantSignDate =
      this.relationshipBo.applicantSignDate != null &&
      this.relationshipBo.applicantSignDate != undefined &&
      this.relationshipBo.applicantSignDate != ""
        ? this.datepipe.transform(
            this.relationshipBo.applicantSignDate,
            "MM/dd/yyyy"
          )
        : null;
    this.relationshipBo.employersSignDate =
      this.relationshipBo.employersSignDate != null &&
      this.relationshipBo.employersSignDate != undefined &&
      this.relationshipBo.employersSignDate != ""
        ? this.datepipe.transform(
            this.relationshipBo.employersSignDate,
            "MM/dd/yyyy"
          )
        : null;

    this.individualDirectSupportBo.previousEmployementEndDate =
      this.individualDirectSupportBo.previousEmployementEndDate != null &&
      this.individualDirectSupportBo.previousEmployementEndDate !=
        undefined &&
      this.individualDirectSupportBo.previousEmployementEndDate != ""
        ? this.datepipe.transform(
            this.individualDirectSupportBo.previousEmployementEndDate,
            "MM/dd/yyyy"
          )
        : null;
    this.individualDirectSupportBo.dob =
      this.individualDirectSupportBo.dob != null &&
      this.individualDirectSupportBo.dob != undefined &&
      this.individualDirectSupportBo.dob != ""
        ? this.datepipe.transform(
            this.individualDirectSupportBo.dob,
            "MM/dd/yyyy"
          )
        : null;

    this.individualDirectSupportBo.optionalTrainingCompletionDate =
      this.individualDirectSupportBo.optionalTrainingCompletionDate !=
        null &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate !=
        undefined &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate != ""
        ? this.datepipe.transform(
            this.individualDirectSupportBo.optionalTrainingCompletionDate,
            "MM/dd/yyyy"
          )
        : null;
    this.individualDirectSupportBo.optionalTrainingExpirationDate =
      this.individualDirectSupportBo.optionalTrainingExpirationDate !=
        null &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != "" &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate !=
        undefined
        ? this.datepipe.transform(
            this.individualDirectSupportBo.optionalTrainingExpirationDate,
            "MM/dd/yyyy"
          )
        : null;
    this.employmentEligibilityBo.dob =
      this.employmentEligibilityBo.dob != null &&
      this.employmentEligibilityBo.dob != undefined &&
      this.employmentEligibilityBo.dob != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.dob,
            "MM/dd/yyyy"
          )
        : null;
    this.employmentEligibilityBo.alien_Registration_ExpiryDate =
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != null &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate !=
        undefined &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.alien_Registration_ExpiryDate,
            "MM/dd/yyyy"
          )
        : null;

    this.employmentEligibilityBo.todaysDate =
      this.employmentEligibilityBo.todaysDate != null &&
      this.employmentEligibilityBo.todaysDate != undefined &&
      this.employmentEligibilityBo.todaysDate != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.todaysDate,
            "MM/dd/yyyy"
          )
        : null;

    this.employmentEligibilityBo.signOfPreparerorTraslatorDate =
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != null &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate !=
        undefined &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.signOfPreparerorTraslatorDate,
            "MM/dd/yyyy"
          )
        : null;

    this.employmentEligibilityBo.expirationDate =
      this.employmentEligibilityBo.expirationDate != null &&
      this.employmentEligibilityBo.expirationDate != undefined &&
      this.employmentEligibilityBo.expirationDate != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.expirationDate,
            "MM/dd/yyyy"
          )
        : null;

    this.employmentEligibilityBo.expirationDate1 =
      this.employmentEligibilityBo.expirationDate1 != null &&
      this.employmentEligibilityBo.expirationDate1 != undefined &&
      this.employmentEligibilityBo.expirationDate1 != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.expirationDate1,
            "MM/dd/yyyy"
          )
        : null;
    this.employmentEligibilityBo.expirationDate2 =
      this.employmentEligibilityBo.expirationDate2 != null &&
      this.employmentEligibilityBo.expirationDate2 != undefined &&
      this.employmentEligibilityBo.expirationDate2 != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.expirationDate2,
            "MM/dd/yyyy"
          )
        : null;
    this.employmentEligibilityBo.expirationDate3 =
      this.employmentEligibilityBo.expirationDate3 != null &&
      this.employmentEligibilityBo.expirationDate3 != undefined &&
      this.employmentEligibilityBo.expirationDate3 != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.expirationDate3,
            "MM/dd/yyyy"
          )
        : null;
    this.employmentEligibilityBo.expirationDate4 =
      this.employmentEligibilityBo.expirationDate4 != null &&
      this.employmentEligibilityBo.expirationDate4 != undefined &&
      this.employmentEligibilityBo.expirationDate4 != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.expirationDate4,
            "MM/dd/yyyy"
          )
        : null;

    this.employmentEligibilityBo.employeesFirstdayEmployment =
      this.employmentEligibilityBo.employeesFirstdayEmployment != null &&
      this.employmentEligibilityBo.employeesFirstdayEmployment !=
        undefined &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.employeesFirstdayEmployment,
            "MM/dd/yyyy"
          )
        : null;

    this.employmentEligibilityBo.employerSignDate1 =
      this.employmentEligibilityBo.employerSignDate1 != null &&
      this.employmentEligibilityBo.employerSignDate1 != undefined &&
      this.employmentEligibilityBo.employerSignDate1 != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.employerSignDate1,
            "MM/dd/yyyy"
          )
        : null;

    this.employmentEligibilityBo.reverificationDate =
      this.employmentEligibilityBo.reverificationDate != null &&
      this.employmentEligibilityBo.reverificationDate != undefined &&
      this.employmentEligibilityBo.reverificationDate != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.reverificationDate,
            "MM/dd/yyyy"
          )
        : null;

    this.employmentEligibilityBo.documentExpiryDate =
      this.employmentEligibilityBo.documentExpiryDate != null &&
      this.employmentEligibilityBo.documentExpiryDate != undefined &&
      this.employmentEligibilityBo.documentExpiryDate != ""
        ? this.datepipe.transform(
            this.employmentEligibilityBo.documentExpiryDate,
            "MM/dd/yyyy"
          )
        : null;

     this.employmentEligibilityBo.employerSignDate3 =(
       this.employmentEligibilityBo.employerSignDate3 != null &&
       this.employmentEligibilityBo.employerSignDate3 != undefined &&
       this.employmentEligibilityBo.employerSignDate3 != "")
         ? this.datepipe.transform(
             this.employmentEligibilityBo.employerSignDate3, "MM/dd/yyyy" )

         : null;

    this.employeesWithholdingBo.signDate =
      this.employeesWithholdingBo.signDate != null &&
      this.employeesWithholdingBo.signDate != undefined &&
      this.employeesWithholdingBo.signDate != ""
        ? this.datepipe.transform(
            this.employeesWithholdingBo.signDate,
            "MM/dd/yyyy"
          )
        : null;

    this.employeesWithholdingBo.firstDateOfEmployeement =
      this.employeesWithholdingBo.firstDateOfEmployeement != null &&
      this.employeesWithholdingBo.firstDateOfEmployeement != undefined &&
      this.employeesWithholdingBo.firstDateOfEmployeement != ""
        ? this.datepipe.transform(
            this.employeesWithholdingBo.firstDateOfEmployeement,
            "MM/dd/yyyy"
          )
        : null;

    this.w4MinnesotaWithholdingBo.date =
      this.w4MinnesotaWithholdingBo.date != null &&
      this.w4MinnesotaWithholdingBo.date != undefined &&
      this.w4MinnesotaWithholdingBo.date != ""
        ? this.datepipe.transform(
            this.w4MinnesotaWithholdingBo.date,
            "MM/dd/yyyy"
          )
        : null;
    this.individualSupportWorkerBo.signDate =
      this.individualSupportWorkerBo.signDate != null &&
      this.individualSupportWorkerBo.signDate != undefined &&
      this.individualSupportWorkerBo.signDate != ""
        ? this.datepipe.transform(
            this.individualSupportWorkerBo.signDate,
            "MM/dd/yyyy"
          )
        : null;
        this.individualDirectSupportBo.signDate =
      this.individualDirectSupportBo.signDate != null &&
      this.individualDirectSupportBo.signDate != undefined &&
      this.individualDirectSupportBo.signDate != ""
        ? this.datepipe.transform(
            this.individualDirectSupportBo.signDate,
            "MM/dd/yyyy"
          )
        : null;

    this.prepopulatefun();
    this.prepopulateclientfun();
  });
}
    
  }

  ngAfterContentChecked() {
    this.backgroundBo.dob =
      (this.backgroundBo.dob != null &&
      this.backgroundBo.dob != undefined &&
      this.backgroundBo.dob != "")
        ? this.backgroundBo.dob
        : null;
    this.backgroundBo.previousNamesUsedDate1 =(
      this.backgroundBo.previousNamesUsedDate1 != null &&
      this.backgroundBo.previousNamesUsedDate1 != undefined &&
      this.backgroundBo.previousNamesUsedDate1 != "")
        ? this.backgroundBo.previousNamesUsedDate1
        : null;
    this.backgroundBo.previousNamesUsedDate2 =(
      this.backgroundBo.previousNamesUsedDate2 != null &&
      this.backgroundBo.previousNamesUsedDate2 != undefined &&
      this.backgroundBo.previousNamesUsedDate2 != "")
        ? this.backgroundBo.previousNamesUsedDate2
        : null;
    this.backgroundBo.previous_Addresses_UsedDate1 =(
      this.backgroundBo.previous_Addresses_UsedDate1 != null &&
      this.backgroundBo.previous_Addresses_UsedDate1 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate1 != "")
        ? this.backgroundBo.previous_Addresses_UsedDate1
        : null;
    this.backgroundBo.previous_Addresses_UsedDate2 =(
      this.backgroundBo.previous_Addresses_UsedDate2 != null &&
      this.backgroundBo.previous_Addresses_UsedDate2 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate2 != "")
        ? this.backgroundBo.previous_Addresses_UsedDate2
        : null;
    this.backgroundBo.previous_Addresses_UsedDate3 =(
      this.backgroundBo.previous_Addresses_UsedDate3 != null &&
      this.backgroundBo.previous_Addresses_UsedDate3 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate3 != "")
        ? this.backgroundBo.previous_Addresses_UsedDate3
        : null;

    this.backgroundBo.applicantSignatureDate =(
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != "")
        ? this.backgroundBo.applicantSignatureDate
        : null;
    this.backgroundBo.parentSignatureDate =(
      this.backgroundBo.parentSignatureDate != null &&
      this.backgroundBo.parentSignatureDate != undefined &&
      this.backgroundBo.parentSignatureDate != "")
        ? this.backgroundBo.parentSignatureDate
        : null;
    this.payNoticeBo.employeeSignDate =(
      this.payNoticeBo.employeeSignDate != null &&
      this.payNoticeBo.employeeSignDate != undefined &&
      this.payNoticeBo.employeeSignDate != "")
        ? this.payNoticeBo.employeeSignDate
        : null;
    this.payNoticeBo.employerSignDate =(
      this.payNoticeBo.employerSignDate != null &&
      this.payNoticeBo.employerSignDate != undefined &&
      this.payNoticeBo.employerSignDate != "")
        ? this.payNoticeBo.employerSignDate
        : null;

    this.relationshipBo.dob =(
      this.relationshipBo.dob != null &&
      this.relationshipBo.dob != undefined &&
      this.relationshipBo.dob != "")
        ? this.relationshipBo.dob
        : null;
    this.relationshipBo.applicantSignDate =(
      this.relationshipBo.applicantSignDate != null &&
      this.relationshipBo.applicantSignDate != undefined &&
      this.relationshipBo.applicantSignDate != "")
        ? this.relationshipBo.applicantSignDate
        : null;
    this.relationshipBo.employersSignDate =(
      this.relationshipBo.employersSignDate != null &&
      this.relationshipBo.employersSignDate != undefined &&
      this.relationshipBo.employersSignDate != "")
        ? this.relationshipBo.employersSignDate
        : null;

    this.individualDirectSupportBo.previousEmployementEndDate =(
      this.individualDirectSupportBo.previousEmployementEndDate != null &&
      this.individualDirectSupportBo.previousEmployementEndDate != undefined &&
      this.individualDirectSupportBo.previousEmployementEndDate != "")
        ? this.individualDirectSupportBo.previousEmployementEndDate
        : null;
    this.individualDirectSupportBo.dob =(
      this.individualDirectSupportBo.dob != null &&
      this.individualDirectSupportBo.dob != undefined &&
      this.individualDirectSupportBo.dob != "")
        ? this.individualDirectSupportBo.dob
        : null;

    this.individualDirectSupportBo.optionalTrainingCompletionDate =(
      this.individualDirectSupportBo.optionalTrainingCompletionDate != null &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate !=
        undefined &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate != "")
        ? this.individualDirectSupportBo.optionalTrainingCompletionDate
        : null;
    this.individualDirectSupportBo.optionalTrainingExpirationDate =(
      this.individualDirectSupportBo.optionalTrainingExpirationDate != null &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != "" &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != undefined)
        ? this.individualDirectSupportBo.optionalTrainingExpirationDate
        : null;
    this.employmentEligibilityBo.dob =(
      this.employmentEligibilityBo.dob != null &&
      this.employmentEligibilityBo.dob != undefined &&
      this.employmentEligibilityBo.dob != "")
        ? this.employmentEligibilityBo.dob
        : null;
    this.employmentEligibilityBo.alien_Registration_ExpiryDate =(
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != null &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != undefined &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != "")
        ? this.employmentEligibilityBo.alien_Registration_ExpiryDate
        : null;

    this.employmentEligibilityBo.todaysDate =(
      this.employmentEligibilityBo.todaysDate != null &&
      this.employmentEligibilityBo.todaysDate != undefined &&
      this.employmentEligibilityBo.todaysDate != "")
        ? this.employmentEligibilityBo.todaysDate
        : null;

    this.employmentEligibilityBo.signOfPreparerorTraslatorDate =(
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != null &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != undefined &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != "")
        ? this.employmentEligibilityBo.signOfPreparerorTraslatorDate
        : null;

    this.employmentEligibilityBo.expirationDate =(
      this.employmentEligibilityBo.expirationDate != null &&
      this.employmentEligibilityBo.expirationDate != undefined &&
      this.employmentEligibilityBo.expirationDate != "")
        ? this.employmentEligibilityBo.expirationDate
        : null;

    this.employmentEligibilityBo.expirationDate1 =(
      this.employmentEligibilityBo.expirationDate1 != null &&
      this.employmentEligibilityBo.expirationDate1 != undefined &&
      this.employmentEligibilityBo.expirationDate1 != "")
        ? this.employmentEligibilityBo.expirationDate1
        : null;
    this.employmentEligibilityBo.expirationDate2 =(
      this.employmentEligibilityBo.expirationDate2 != null &&
      this.employmentEligibilityBo.expirationDate2 != undefined &&
      this.employmentEligibilityBo.expirationDate2 != "")
        ? this.employmentEligibilityBo.expirationDate2
        : null;
    this.employmentEligibilityBo.expirationDate3 =(
      this.employmentEligibilityBo.expirationDate3 != null &&
      this.employmentEligibilityBo.expirationDate3 != undefined &&
      this.employmentEligibilityBo.expirationDate3 != "")
        ? this.employmentEligibilityBo.expirationDate3
        : null;
    this.employmentEligibilityBo.expirationDate4 =(
      this.employmentEligibilityBo.expirationDate4 != null &&
      this.employmentEligibilityBo.expirationDate4 != undefined &&
      this.employmentEligibilityBo.expirationDate4 != "")
        ? this.employmentEligibilityBo.expirationDate4
        : null;

    this.employmentEligibilityBo.employeesFirstdayEmployment =(
      this.employmentEligibilityBo.employeesFirstdayEmployment != null &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != undefined &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != "")
        ? this.employmentEligibilityBo.employeesFirstdayEmployment
        : null;

    this.employmentEligibilityBo.employerSignDate1 =(
      this.employmentEligibilityBo.employerSignDate1 != null &&
      this.employmentEligibilityBo.employerSignDate1 != undefined &&
      this.employmentEligibilityBo.employerSignDate1 != "")
        ? this.employmentEligibilityBo.employerSignDate1
        : null;

    this.employmentEligibilityBo.reverificationDate =(
      this.employmentEligibilityBo.reverificationDate != null &&
      this.employmentEligibilityBo.reverificationDate != undefined &&
      this.employmentEligibilityBo.reverificationDate != "")
        ? this.employmentEligibilityBo.reverificationDate
        : null;

    this.employmentEligibilityBo.documentExpiryDate =(
      this.employmentEligibilityBo.documentExpiryDate != null &&
      this.employmentEligibilityBo.documentExpiryDate != undefined &&
      this.employmentEligibilityBo.documentExpiryDate != "")
        ? this.employmentEligibilityBo.documentExpiryDate
        : null;

    this.employmentEligibilityBo.employerSignDate3 =(
      this.employmentEligibilityBo.employerSignDate3 != null &&
      this.employmentEligibilityBo.employerSignDate3 != undefined &&
      this.employmentEligibilityBo.employerSignDate3 != "")
        ?  (
            this.employmentEligibilityBo.employerSignDate3 )

        : null;

    this.employeesWithholdingBo.signDate =(
      this.employeesWithholdingBo.signDate != null &&
      this.employeesWithholdingBo.signDate != undefined &&
      this.employeesWithholdingBo.signDate != "")
        ? this.employeesWithholdingBo.signDate
        : null;

    this.employeesWithholdingBo.firstDateOfEmployeement =(
      this.employeesWithholdingBo.firstDateOfEmployeement != null &&
      this.employeesWithholdingBo.firstDateOfEmployeement != undefined &&
      this.employeesWithholdingBo.firstDateOfEmployeement != "")
        ? this.employeesWithholdingBo.firstDateOfEmployeement
        : null;

    this.w4MinnesotaWithholdingBo.date =(
      this.w4MinnesotaWithholdingBo.date != null &&
      this.w4MinnesotaWithholdingBo.date != undefined &&
      this.w4MinnesotaWithholdingBo.date != "")
        ? this.w4MinnesotaWithholdingBo.date
        : null;
    this.individualSupportWorkerBo.signDate = (
      this.individualSupportWorkerBo.signDate != null &&
      this.individualSupportWorkerBo.signDate != undefined &&
      this.individualSupportWorkerBo.signDate != "")
        ? this.individualSupportWorkerBo.signDate
        : null;
        this.individualDirectSupportBo.signDate = (
          this.individualDirectSupportBo.signDate != null &&
          this.individualDirectSupportBo.signDate != undefined &&
          this.individualDirectSupportBo.signDate != "")
            ? this.individualDirectSupportBo.signDate
            : null;
        
  }

  spouse:string
  strigToBooleanRadio(){
    let ab:any
    ab =this.spouse
    // this.relationshipBo.employerandWantWorkers
    this.relationshipBo.employerandWantWorkers=JSON.parse(ab)
  }
  IDSWFormRadio1(){
    let ab:any
    ab =this.individualDirectSupportBoRadio1    
    this.individualDirectSupportBo.isMcoClaimsOnly=JSON.parse(ab)
  }
  IDSWFormRadio2(){
    let ab:any
    ab =this.individualDirectSupportBoRadio2
    this.individualDirectSupportBo.isQualifiedEnhancedRateTraining=JSON.parse(ab)
  }
  individualDirectSupportBoRadio1:string;
  individualDirectSupportBoRadio2:string;
  individualDirectSupportBoRadio3:string;


  IDSWFormRadio3(){
    let ab:any
    ab =this.individualDirectSupportBoRadio3
    this.individualDirectSupportBo.isAffiliateIndividualDsw=JSON.parse(ab)

  }

 
  saveAgreementcomplete() {
    // this.relationshipBo.employerandWantWorkers =JSON.parse(this.relationshipBo.employerandWantWorkers)
    this.relationshipBo.relationshipName=this.reationshipname
    this.individualSupportWorkerBo.signDate =(
      this.individualSupportWorkerBo.signDate != null &&
      this.individualSupportWorkerBo.signDate != undefined &&
      this.individualSupportWorkerBo.signDate != "")
        ? this.global.getDateTimeString(this.individualSupportWorkerBo.signDate)
        : null;
        this.individualDirectSupportBo.signDate =(
          this.individualDirectSupportBo.signDate != null &&
          this.individualDirectSupportBo.signDate != undefined &&
          this.individualDirectSupportBo.signDate != "")
            ? this.global.getDateTimeString(this.individualDirectSupportBo.signDate)
            : null;

    this.backgroundBo.dob =(
      this.backgroundBo.dob != null &&
      this.backgroundBo.dob != undefined &&
      this.backgroundBo.dob != "")
        ? this.global.getDateTimeString(this.backgroundBo.dob)
        : null;
    this.backgroundBo.previousNamesUsedDate1 =(
      this.backgroundBo.previousNamesUsedDate1 != null &&
      this.backgroundBo.previousNamesUsedDate1 != undefined &&
      this.backgroundBo.previousNamesUsedDate1 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previousNamesUsedDate1
          )
        : null;
    this.backgroundBo.previousNamesUsedDate2 =(
      this.backgroundBo.previousNamesUsedDate2 != null &&
      this.backgroundBo.previousNamesUsedDate2 != undefined &&
      this.backgroundBo.previousNamesUsedDate2 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previousNamesUsedDate2
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate1 =(
      this.backgroundBo.previous_Addresses_UsedDate1 != null &&
      this.backgroundBo.previous_Addresses_UsedDate1 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate1 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate1
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate2 =(
      this.backgroundBo.previous_Addresses_UsedDate2 != null &&
      this.backgroundBo.previous_Addresses_UsedDate2 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate2 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate2
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate3 =(
      this.backgroundBo.previous_Addresses_UsedDate3 != null &&
      this.backgroundBo.previous_Addresses_UsedDate3 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate3 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate3
          )
        : null;

    this.backgroundBo.applicantSignatureDate =(
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.applicantSignatureDate
          )
        : null;
    this.backgroundBo.parentSignatureDate =(
      this.backgroundBo.parentSignatureDate != null &&
      this.backgroundBo.parentSignatureDate != undefined &&
      this.backgroundBo.parentSignatureDate != "")
        ? this.global.getDateTimeString(this.backgroundBo.parentSignatureDate)
        : null;
    this.payNoticeBo.employeeSignDate =(
      this.payNoticeBo.employeeSignDate != null &&
      this.payNoticeBo.employeeSignDate != undefined &&
      this.payNoticeBo.employeeSignDate != "")
        ? this.global.getDateTimeString(this.payNoticeBo.employeeSignDate)
        : null;
    this.payNoticeBo.employerSignDate =(
      this.payNoticeBo.employerSignDate != null &&
      this.payNoticeBo.employerSignDate != undefined &&
      this.payNoticeBo.employerSignDate != "")
        ? this.global.getDateTimeString(this.payNoticeBo.employerSignDate)
        : null;

    this.relationshipBo.dob =(
      this.relationshipBo.dob != null &&
      this.relationshipBo.dob != undefined &&
      this.relationshipBo.dob != "")
        ? this.global.getDateTimeString(this.relationshipBo.dob)
        : null;
    this.relationshipBo.applicantSignDate =(
      this.relationshipBo.applicantSignDate != null &&
      this.relationshipBo.applicantSignDate != undefined &&
      this.relationshipBo.applicantSignDate != "")
        ? this.global.getDateTimeString(this.relationshipBo.applicantSignDate)
        : null;
    this.relationshipBo.employersSignDate =(
      this.relationshipBo.employersSignDate != null &&
      this.relationshipBo.employersSignDate != undefined &&
      this.relationshipBo.employersSignDate != "")
        ? this.global.getDateTimeString(this.relationshipBo.employersSignDate)
        : null;

    this.individualDirectSupportBo.previousEmployementEndDate =(
      this.individualDirectSupportBo.previousEmployementEndDate != null &&
      this.individualDirectSupportBo.previousEmployementEndDate != undefined &&
      this.individualDirectSupportBo.previousEmployementEndDate != "")
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.previousEmployementEndDate
          )
        : null;
    this.individualDirectSupportBo.dob =(
      this.individualDirectSupportBo.dob != null &&
      this.individualDirectSupportBo.dob != undefined &&
      this.individualDirectSupportBo.dob != "")
        ? this.global.getDateTimeString(this.individualDirectSupportBo.dob)
        : null;

    this.individualDirectSupportBo.optionalTrainingCompletionDate =(
      this.individualDirectSupportBo.optionalTrainingCompletionDate != null &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate !=
        undefined &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate != "")
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.optionalTrainingCompletionDate
          )
        : null;
    this.individualDirectSupportBo.optionalTrainingExpirationDate =(
      this.individualDirectSupportBo.optionalTrainingExpirationDate != null &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != "" &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != undefined)
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.optionalTrainingExpirationDate
          )
        : null;
    this.employmentEligibilityBo.dob =(
      this.employmentEligibilityBo.dob != null &&
      this.employmentEligibilityBo.dob != undefined &&
      this.employmentEligibilityBo.dob != "")
        ? this.global.getDateTimeString(this.employmentEligibilityBo.dob)
        : null;
    this.employmentEligibilityBo.alien_Registration_ExpiryDate =(
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != null &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != undefined &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.alien_Registration_ExpiryDate
          )
        : null;

    this.employmentEligibilityBo.todaysDate =(
      this.employmentEligibilityBo.todaysDate != null &&
      this.employmentEligibilityBo.todaysDate != undefined &&
      this.employmentEligibilityBo.todaysDate != "")
        ? this.global.getDateTimeString(this.employmentEligibilityBo.todaysDate)
        : null;

    this.employmentEligibilityBo.signOfPreparerorTraslatorDate =(
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != null &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != undefined &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.signOfPreparerorTraslatorDate
          )
        : null;

    this.employmentEligibilityBo.expirationDate =(
      this.employmentEligibilityBo.expirationDate != null &&
      this.employmentEligibilityBo.expirationDate != undefined &&
      this.employmentEligibilityBo.expirationDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate
          )
        : null;

    this.employmentEligibilityBo.expirationDate1 =(
      this.employmentEligibilityBo.expirationDate1 != null &&
      this.employmentEligibilityBo.expirationDate1 != undefined &&
      this.employmentEligibilityBo.expirationDate1 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate1
          )
        : null;
    this.employmentEligibilityBo.expirationDate2 =(
      this.employmentEligibilityBo.expirationDate2 != null &&
      this.employmentEligibilityBo.expirationDate2 != undefined &&
      this.employmentEligibilityBo.expirationDate2 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate2
          )
        : null;
    this.employmentEligibilityBo.expirationDate3 =(
      this.employmentEligibilityBo.expirationDate3 != null &&
      this.employmentEligibilityBo.expirationDate3 != undefined &&
      this.employmentEligibilityBo.expirationDate3 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate3
          )
        : null;
    this.employmentEligibilityBo.expirationDate4 =(
      this.employmentEligibilityBo.expirationDate4 != null &&
      this.employmentEligibilityBo.expirationDate4 != undefined &&
      this.employmentEligibilityBo.expirationDate4 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate4
          )
        : null;

    this.employmentEligibilityBo.employeesFirstdayEmployment =(
      this.employmentEligibilityBo.employeesFirstdayEmployment != null &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != undefined &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.employeesFirstdayEmployment
          )
        : null;

    this.employmentEligibilityBo.employerSignDate1 =(
      this.employmentEligibilityBo.employerSignDate1 != null &&
      this.employmentEligibilityBo.employerSignDate1 != undefined &&
      this.employmentEligibilityBo.employerSignDate1 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.employerSignDate1
          )
        : null;

    this.employmentEligibilityBo.reverificationDate =(
      this.employmentEligibilityBo.reverificationDate != null &&
      this.employmentEligibilityBo.reverificationDate != undefined &&
      this.employmentEligibilityBo.reverificationDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.reverificationDate
          )
        : null;

    this.employmentEligibilityBo.documentExpiryDate =(
      this.employmentEligibilityBo.documentExpiryDate != null &&
      this.employmentEligibilityBo.documentExpiryDate != undefined &&
      this.employmentEligibilityBo.documentExpiryDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.documentExpiryDate
          )
        : null;

    this.employeesWithholdingBo.signDate =(
      this.employeesWithholdingBo.signDate != null &&
      this.employeesWithholdingBo.signDate != undefined &&
      this.employeesWithholdingBo.signDate != "")
        ? this.global.getDateTimeString(this.employeesWithholdingBo.signDate)
        : null;

    this.employeesWithholdingBo.firstDateOfEmployeement =(
      this.employeesWithholdingBo.firstDateOfEmployeement != null &&
      this.employeesWithholdingBo.firstDateOfEmployeement != undefined &&
      this.employeesWithholdingBo.firstDateOfEmployeement != "")
        ? this.global.getDateTimeString(
            this.employeesWithholdingBo.firstDateOfEmployeement
          )
        : null;

    this.w4MinnesotaWithholdingBo.date =(
      this.w4MinnesotaWithholdingBo.date != null &&
      this.w4MinnesotaWithholdingBo.date != undefined &&
      this.w4MinnesotaWithholdingBo.date != "")
        ? this.global.getDateTimeString(this.w4MinnesotaWithholdingBo.date)
        : null;

    this.agreementBo.backgroundStudyAuthorization = this.backgroundBo;

    this.agreementBo.employeeAgreementAndDirectDeposit =
      this.employeeAgreementBo;
    this.agreementBo.employeeApplicationCover = this.employeeApplicationBo;
    this.agreementBo.employeesWithholdingCertificate =
      this.employeesWithholdingBo;
    this.agreementBo.employmentEligibilityVerification =
      this.employmentEligibilityBo;
    this.DSwstudyBo = this.DSwstudyBolist;
    this.individualDirectSupportBo.dswBackgroundStudyInfoForms =
      this.DSwstudyBo;
    this.agreementBo.individualDirectSupportWorkerEnrollmentApplication =
      this.individualDirectSupportBo;

    this.agreementBo.individualSupportWorkerProviderAgreement =
      this.individualSupportWorkerBo;

    this.agreementBo.payNotice = this.payNoticeBo;
    this.relationshipBo.relationshipDisclosureTaxDetails =
      this.relationdisclosureBo;
    this.agreementBo.relationshipDisclosure = this.relationshipBo;
    this.agreementBo.w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipients =
      this.w4MNInstructionsBo;
    this.agreementBo.w4MinnesotaWithholdingAllowanceOrExemptionCertificate =
      this.w4MinnesotaWithholdingBo;

    this.backgroundBo.applicantSignature = this.appsign1;
    this.backgroundBo.parentSignature = this.sign4;

    this.payNoticeBo.employeeSign = this.Gurdsign3;
    this.payNoticeBo.employerSign = this.employeesign2;

    this.relationshipBo.employersSign = this.clientsign0;
    this.relationshipBo.applicantSign = this.employeesign3;
    this.employeeAgreementBo.employee_sign = this.clientsign2;

    this.individualDirectSupportBo.sign = this.individualsign;

    this.individualSupportWorkerBo.sign = this.repsign;

    this.employmentEligibilityBo.signOfEmployee = this.employeesign;
    this.employmentEligibilityBo.employerSign = this.translatorsign;
    this.employmentEligibilityBo.employerSign1 = this.authorizedsign;
    this.employmentEligibilityBo.signOfPreparerorTraslator =
      this.authorizedrepsign;

    this.employeesWithholdingBo.employeeSignature = this.Gurdsign;
    this.w4MinnesotaWithholdingBo.signature = this.clientsign1;

    this.agreementBo.clientId = this.emitemployeeBO.clientid;
    this.agreementBo.employeeId = this.emitemployeeBO.employeeid;
    this.agreementBo.id = this.emitemployeeBO.agreementId;
    // if (this.global.OnboardingLoginType != "onboardLogin") {
    //   this.agreementService
    //     .saveEmployeeAgreement(this.agreementBo)
    //     .pipe(takeUntil(this.onDestroy$))
    //     .subscribe(
    //       (data) => {
    //         this.emitemployeeBO.agreementId = data;
    //         this.toastrService.success("Employee Agreement Saved Successfully");
    //       },
    //       (err: HttpErrorResponse) => {
    //         this.toastrService.error(err.error, "error");
    //         setTimeout(() => {
    //           this.toastrService.clear();
    //         }, 8000);
    //       }
    //     );
    // } else {
      this.agreementService
        .saveEmployeeAgreementComplete(this.agreementBo)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.toastrService.success("Employee Agreement Saved Successfully");
            this.DataToClientOnBoardList();
          },
          (err: HttpErrorResponse) => {
            this.toastrService.error(err.error, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
    // }
  }


  sectionDetermine(event) {
    
    if(event.target.value=="false"){
      this.Section2Form.reset()
      this.Section2Form.disable();
      this.Section1Form.enable();
       this.w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2=''
      
    }
    else if(event.target.value=="true"){
      this.Section1Form.reset()
      this.Section1Form.disable();
      this.Section2Form.enable();
    }
  }

  option_section2(event){
    
    if(event.target.value=="C"){
      this.Section2Form.enable();
     this.w4MinnesotaWithholdingBo.reservation_name=""
     this.w4MinnesotaWithholdingBo.enroll_no=""
     this.Section2Form.controls['input2'].disable();
     this.Section2Form.controls['input3'].disable();
     this.Section2Form.controls['input1'].enable();
     
  }
  if(event.target.value=="D"){
    this.Section2Form.enable();
   this.w4MinnesotaWithholdingBo.state_domicile=""
   this.Section2Form.controls['input1'].disable();
   this.Section2Form.controls['input2'].enable();
   this.Section2Form.controls['input3'].enable();
    
  }

  if(event.target.value!="C" && event.target.value!="D"){
    this.w4MinnesotaWithholdingBo.state_domicile=""
    this.w4MinnesotaWithholdingBo.reservation_name=""
    this.w4MinnesotaWithholdingBo.enroll_no=""
    this.Section2Form.disable();
  }

}

sendtoemployer=new SendToClientBO();
sendtoemployee=new SendToEmployeeBO(); 
SentToEmployer(){
  this.SetValuesForAgreement().then((data)=> {
    this.sendtoemployer.employeeagreementId=this.emitemployeeBO.agreementId
    this.sendtoemployer.id=this.emitemployeeBO.clientid   
    this.sendtoemployer.portalLink=  this.configurationservice.environment.onboardingUrl +'#/onboarding/client/'
    this.sendtoemployer.documentValue=this.agreementBo
    this.agreementService.SentToEmployer(this.sendtoemployer).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success("Agreement Sent to Employer")
        document.getElementById("sendToEmployermodal").click()
        this.DataToClientOnBoardList();
  
  },
  (err: HttpErrorResponse) => {
    this.toastrService.error(
      err.error,
      "error",
    );
    setTimeout(() => {
      this.toastrService.clear()
    }, 8000);
  
  })
  });

}

SentToEmployee(){
  this.SetValuesForAgreement().then((data)=> {
    this.sendtoemployee.employeeagreementId=this.emitemployeeBO.agreementId
    this.sendtoemployee.id=this.emitemployeeBO.employeeid
    this.sendtoemployee.portalLink= this.configurationservice.environment.onboardingUrl+'#/onboarding/employee/'
    this.sendtoemployee.documentValue=this.agreementBo
    this.agreementService.SentToEmployee(this.sendtoemployee).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Agreement Sent to Employee")
      document.getElementById("sendToEmployeModal").click()
      this.DataToClientOnBoardList();
    },
    (err: HttpErrorResponse) => {
      this.toastrService.error(
        err.error,
        "error",
      );
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
  
    });
  });
  
}



SetValuesForAgreement(){
 
    // this.relationshipBo.employerandWantWorkers =JSON.parse(this.relationshipBo.employerandWantWorkers)
return new Promise((resolve, reject) => {
    this.individualSupportWorkerBo.signDate =(
      this.individualSupportWorkerBo.signDate != null &&
      this.individualSupportWorkerBo.signDate != undefined &&
      this.individualSupportWorkerBo.signDate != "")
        ? this.global.getDateTimeString(this.individualSupportWorkerBo.signDate)
        : null;
        this.individualDirectSupportBo.signDate =(
          this.individualDirectSupportBo.signDate != null &&
          this.individualDirectSupportBo.signDate != undefined &&
          this.individualDirectSupportBo.signDate != "")
            ? this.global.getDateTimeString(this.individualDirectSupportBo.signDate)
            : null;
    this.backgroundBo.firstName= this.backgroundBo.firstName;
    this.backgroundBo.dob =(
      this.backgroundBo.dob != null &&
      this.backgroundBo.dob != undefined &&
      this.backgroundBo.dob != "")
        ? this.global.getDateTimeString(this.backgroundBo.dob)
        : null;
    this.backgroundBo.previousNamesUsedDate1 =(
      this.backgroundBo.previousNamesUsedDate1 != null &&
      this.backgroundBo.previousNamesUsedDate1 != undefined &&
      this.backgroundBo.previousNamesUsedDate1 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previousNamesUsedDate1
          )
        : null;
    this.backgroundBo.previousNamesUsedDate2 =(
      this.backgroundBo.previousNamesUsedDate2 != null &&
      this.backgroundBo.previousNamesUsedDate2 != undefined &&
      this.backgroundBo.previousNamesUsedDate2 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previousNamesUsedDate2
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate1 =(
      this.backgroundBo.previous_Addresses_UsedDate1 != null &&
      this.backgroundBo.previous_Addresses_UsedDate1 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate1 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate1
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate2 =(
      this.backgroundBo.previous_Addresses_UsedDate2 != null &&
      this.backgroundBo.previous_Addresses_UsedDate2 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate2 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate2
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate3 =(
      this.backgroundBo.previous_Addresses_UsedDate3 != null &&
      this.backgroundBo.previous_Addresses_UsedDate3 != undefined &&
      this.backgroundBo.previous_Addresses_UsedDate3 != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate3
          )
        : null;

    this.backgroundBo.applicantSignatureDate =(
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != null &&
      this.backgroundBo.applicantSignatureDate != "")
        ? this.global.getDateTimeString(
            this.backgroundBo.applicantSignatureDate
          )
        : null;
    this.backgroundBo.parentSignatureDate =(
      this.backgroundBo.parentSignatureDate != null &&
      this.backgroundBo.parentSignatureDate != undefined &&
      this.backgroundBo.parentSignatureDate != "")
        ? this.global.getDateTimeString(this.backgroundBo.parentSignatureDate)
        : null;
    this.payNoticeBo.employeeSignDate =(
      this.payNoticeBo.employeeSignDate != null &&
      this.payNoticeBo.employeeSignDate != undefined &&
      this.payNoticeBo.employeeSignDate != "")
        ? this.global.getDateTimeString(this.payNoticeBo.employeeSignDate)
        : null;
    this.payNoticeBo.employerSignDate =(
      this.payNoticeBo.employerSignDate != null &&
      this.payNoticeBo.employerSignDate != undefined &&
      this.payNoticeBo.employerSignDate != "")
        ? this.global.getDateTimeString(this.payNoticeBo.employerSignDate)
        : null;

    this.relationshipBo.dob =(
      this.relationshipBo.dob != null &&
      this.relationshipBo.dob != undefined &&
      this.relationshipBo.dob != "")
        ? this.global.getDateTimeString(this.relationshipBo.dob)
        : null;
    this.relationshipBo.applicantSignDate =(
      this.relationshipBo.applicantSignDate != null &&
      this.relationshipBo.applicantSignDate != undefined &&
      this.relationshipBo.applicantSignDate != "")
        ? this.global.getDateTimeString(this.relationshipBo.applicantSignDate)
        : null;
    this.relationshipBo.employersSignDate =(
      this.relationshipBo.employersSignDate != null &&
      this.relationshipBo.employersSignDate != undefined &&
      this.relationshipBo.employersSignDate != "")
        ? this.global.getDateTimeString(this.relationshipBo.employersSignDate)
        : null;

    this.individualDirectSupportBo.previousEmployementEndDate =(
      this.individualDirectSupportBo.previousEmployementEndDate != null &&
      this.individualDirectSupportBo.previousEmployementEndDate != undefined &&
      this.individualDirectSupportBo.previousEmployementEndDate != "")
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.previousEmployementEndDate
          )
        : null;
    this.individualDirectSupportBo.dob =(
      this.individualDirectSupportBo.dob != null &&
      this.individualDirectSupportBo.dob != undefined &&
      this.individualDirectSupportBo.dob != "")
        ? this.global.getDateTimeString(this.individualDirectSupportBo.dob)
        : null;

    this.individualDirectSupportBo.optionalTrainingCompletionDate =(
      this.individualDirectSupportBo.optionalTrainingCompletionDate != null &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate !=
        undefined &&
      this.individualDirectSupportBo.optionalTrainingCompletionDate != "")
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.optionalTrainingCompletionDate
          )
        : null;
    this.individualDirectSupportBo.optionalTrainingExpirationDate =(
      this.individualDirectSupportBo.optionalTrainingExpirationDate != null &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != "" &&
      this.individualDirectSupportBo.optionalTrainingExpirationDate != undefined)
        ? this.global.getDateTimeString(
            this.individualDirectSupportBo.optionalTrainingExpirationDate
          )
        : null;
    this.employmentEligibilityBo.dob =(
      this.employmentEligibilityBo.dob != null &&
      this.employmentEligibilityBo.dob != undefined &&
      this.employmentEligibilityBo.dob != "")
        ? this.global.getDateTimeString(this.employmentEligibilityBo.dob)
        : null;
    this.employmentEligibilityBo.alien_Registration_ExpiryDate =(
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != null &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != undefined &&
      this.employmentEligibilityBo.alien_Registration_ExpiryDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.alien_Registration_ExpiryDate
          )
        : null;

    this.employmentEligibilityBo.todaysDate =(
      this.employmentEligibilityBo.todaysDate != null &&
      this.employmentEligibilityBo.todaysDate != undefined &&
      this.employmentEligibilityBo.todaysDate != "")
        ? this.global.getDateTimeString(this.employmentEligibilityBo.todaysDate)
        : null;

    this.employmentEligibilityBo.signOfPreparerorTraslatorDate =(
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != null &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != undefined &&
      this.employmentEligibilityBo.signOfPreparerorTraslatorDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.signOfPreparerorTraslatorDate
          )
        : null;

    this.employmentEligibilityBo.expirationDate =(
      this.employmentEligibilityBo.expirationDate != null &&
      this.employmentEligibilityBo.expirationDate != undefined &&
      this.employmentEligibilityBo.expirationDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate
          )
        : null;

    this.employmentEligibilityBo.expirationDate1 =(
      this.employmentEligibilityBo.expirationDate1 != null &&
      this.employmentEligibilityBo.expirationDate1 != undefined &&
      this.employmentEligibilityBo.expirationDate1 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate1
          )
        : null;
    this.employmentEligibilityBo.expirationDate2 =(
      this.employmentEligibilityBo.expirationDate2 != null &&
      this.employmentEligibilityBo.expirationDate2 != undefined &&
      this.employmentEligibilityBo.expirationDate2 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate2
          )
        : null;
    this.employmentEligibilityBo.expirationDate3 =(
      this.employmentEligibilityBo.expirationDate3 != null &&
      this.employmentEligibilityBo.expirationDate3 != undefined &&
      this.employmentEligibilityBo.expirationDate3 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate3
          )
        : null;
    this.employmentEligibilityBo.expirationDate4 =(
      this.employmentEligibilityBo.expirationDate4 != null &&
      this.employmentEligibilityBo.expirationDate4 != undefined &&
      this.employmentEligibilityBo.expirationDate4 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.expirationDate4
          )
        : null;

    this.employmentEligibilityBo.employeesFirstdayEmployment =(
      this.employmentEligibilityBo.employeesFirstdayEmployment != null &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != undefined &&
      this.employmentEligibilityBo.employeesFirstdayEmployment != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.employeesFirstdayEmployment
          )
        : null;

    this.employmentEligibilityBo.employerSignDate1 =(
      this.employmentEligibilityBo.employerSignDate1 != null &&
      this.employmentEligibilityBo.employerSignDate1 != undefined &&
      this.employmentEligibilityBo.employerSignDate1 != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.employerSignDate1
          )
        : null;

        this.employmentEligibilityBo.employerSignDate3 =(
          this.employmentEligibilityBo.employerSignDate3 != null &&
          this.employmentEligibilityBo.employerSignDate3 != undefined &&
          this.employmentEligibilityBo.employerSignDate3 != "")
            ? this.global.getDateTimeString(
                this.employmentEligibilityBo.employerSignDate1
              )
            : null;

    this.employmentEligibilityBo.reverificationDate =(
      this.employmentEligibilityBo.reverificationDate != null &&
      this.employmentEligibilityBo.reverificationDate != undefined &&
      this.employmentEligibilityBo.reverificationDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.reverificationDate
          )
        : null;

    this.employmentEligibilityBo.documentExpiryDate =(
      this.employmentEligibilityBo.documentExpiryDate != null &&
      this.employmentEligibilityBo.documentExpiryDate != undefined &&
      this.employmentEligibilityBo.documentExpiryDate != "")
        ? this.global.getDateTimeString(
            this.employmentEligibilityBo.documentExpiryDate
          )
        : null;

    this.employeesWithholdingBo.signDate =(
      this.employeesWithholdingBo.signDate != null &&
      this.employeesWithholdingBo.signDate != undefined &&
      this.employeesWithholdingBo.signDate != "")
        ? this.global.getDateTimeString(this.employeesWithholdingBo.signDate)
        : null;

    this.employeesWithholdingBo.firstDateOfEmployeement =(
      this.employeesWithholdingBo.firstDateOfEmployeement != null &&
      this.employeesWithholdingBo.firstDateOfEmployeement != undefined &&
      this.employeesWithholdingBo.firstDateOfEmployeement != "")
        ? this.global.getDateTimeString(
            this.employeesWithholdingBo.firstDateOfEmployeement
          )
        : null;

    this.w4MinnesotaWithholdingBo.date =(
      this.w4MinnesotaWithholdingBo.date != null &&
      this.w4MinnesotaWithholdingBo.date != undefined &&
      this.w4MinnesotaWithholdingBo.date != "")
        ? this.global.getDateTimeString(this.w4MinnesotaWithholdingBo.date)
        : null;
        this.relationshipBo.relationshipName=this.reationshipname
    this.agreementBo.backgroundStudyAuthorization = this.backgroundBo;

    this.agreementBo.employeeAgreementAndDirectDeposit =
      this.employeeAgreementBo;
    this.agreementBo.employeeApplicationCover = this.employeeApplicationBo;
    this.agreementBo.employeesWithholdingCertificate =
      this.employeesWithholdingBo;
    this.agreementBo.employmentEligibilityVerification =
      this.employmentEligibilityBo;
    this.DSwstudyBo = this.DSwstudyBolist;
    this.individualDirectSupportBo.dswBackgroundStudyInfoForms =
      this.DSwstudyBo;
    this.agreementBo.individualDirectSupportWorkerEnrollmentApplication =
      this.individualDirectSupportBo;

    this.agreementBo.individualSupportWorkerProviderAgreement =
      this.individualSupportWorkerBo;

    this.agreementBo.payNotice = this.payNoticeBo;
    this.relationshipBo.relationshipDisclosureTaxDetails =
      this.relationdisclosureBo;
    this.agreementBo.relationshipDisclosure = this.relationshipBo;
    this.agreementBo.w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipients =
      this.w4MNInstructionsBo;
    this.agreementBo.w4MinnesotaWithholdingAllowanceOrExemptionCertificate =
      this.w4MinnesotaWithholdingBo;

    this.backgroundBo.applicantSignature = this.appsign1;
    this.backgroundBo.parentSignature = this.sign4;

    this.payNoticeBo.employeeSign = this.Gurdsign3;
    this.payNoticeBo.employerSign = this.employeesign2;

    this.relationshipBo.employersSign = this.clientsign0;
    this.relationshipBo.applicantSign = this.employeesign3;
    this.employeeAgreementBo.employee_sign = this.clientsign2;

    this.individualDirectSupportBo.sign = this.individualsign;

    this.individualSupportWorkerBo.sign = this.repsign;

    this.employmentEligibilityBo.signOfEmployee = this.employeesign;
    this.employmentEligibilityBo.employerSign = this.translatorsign;
    this.employmentEligibilityBo.employerSign1 = this.authorizedsign;
    this.employmentEligibilityBo.signOfPreparerorTraslator =
      this.authorizedrepsign;

    this.employeesWithholdingBo.employeeSignature = this.Gurdsign;
    this.w4MinnesotaWithholdingBo.signature = this.clientsign1;

    this.agreementBo.clientId = this.emitemployeeBO.clientid;
    this.agreementBo.employeeId = this.emitemployeeBO.employeeid;
    this.agreementBo.id = this.emitemployeeBO.agreementId;
    resolve(this.agreementBo)
});
}

abc(){
  
}


empDocumentDownload(){
  this.toastrService.success("PDF is Downloading!"),4000;
  (this.pdfOnboardinglistEmp.A3 = true ),
  (this.pdfOnboardinglistEmp.portrait = true ),
  (this.pdfOnboardinglistEmp.keepTogether = ".prevent-split" ),
  (this.pdfOnboardinglistEmp.scale = 0.8 ),
  (this.pdfOnboardinglistEmp.height = 100 ),
  (this.pdfOnboardinglistEmp.margin = {
    left: "0.2cm",
    top: "1cm",
    right: "0.2cm",
    bottom: "1cm",
  }),
  this.pdfOnboardinglistEmp.padding = "10rem"
  this.pdfOnboardinglistEmp.forcePageBreak = (this.singlePrint==false)?".page-break-before":"page-break-before-single";
  this.pdfOnboardinglistEmp.saveAs('EmployeeAgreementtReport.pdf');


  
}
backgroundB1:any;
EmpDocId:any;
EMPAppCover:boolean=false;
BackAuth:boolean=false;
IndividualProviderAgree:boolean=false;
PayNotice:boolean=false;
RelationDisclosure:boolean=false;
DirectDeposit:boolean=false;
IndividualDSWEA:boolean=false;
EmpEVerifyDepart:boolean=false;
EmpWithHoldCertify:boolean=false;
EmpW4Pension:boolean=false;
MinnsottaWithHold:boolean=false;
singlePrint:boolean=false;

GetEmpOnboardDeatalis(formName){
  this.getEmployeeDetails();
 if(formName!=""){
  this.singlePrint=true;
  if(formName=="EMPAppCover"){
    this.EMPAppCover=true
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=false
    this.BackAuth=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;
   }
   
   else if(formName=="BackAuth"){
    this.EMPAppCover=false
    this.IndividualProviderAgree=false
    this.BackAuth=true
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
   else if(formName=="IndividualProviderAgree"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=true
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
   else if(formName=="PayNotice"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=true
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
   else if(formName=="RelationDisclosure"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=true
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
   else if(formName=="DirectDeposit"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=true
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
   else if(formName=="IndividualDSWEA"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=true
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
   else if(formName=="EmpEVerifyDepart"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=true
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
   else if(formName=="EmpWithHoldCertify"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpWithHoldCertify=true
    this.EmpW4Pension=false
    this.MinnsottaWithHold=false;

   }
   else if(formName=="EmpEVerifyDepart"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=true
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
   else if(formName=="MinnsottaWithHold"){
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=false
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=true;


   }
   else{
    this.EMPAppCover=false
    this.BackAuth=false
    this.IndividualProviderAgree=false
    this.PayNotice=false
    this.RelationDisclosure=false
    this.DirectDeposit=false
    this.IndividualDSWEA=false
    this.EmpEVerifyDepart=false
    this.EmpW4Pension=true
    this.EmpWithHoldCertify=false
    this.MinnsottaWithHold=false;


   }
 }
 else{
  this.singlePrint=false;
  this.EMPAppCover=true
  this.BackAuth=true
  this.IndividualProviderAgree=true
  this.PayNotice=true
  this.RelationDisclosure=true
  this.DirectDeposit=true
  this.IndividualDSWEA=true
  this.EmpEVerifyDepart=true
  this.EmpW4Pension=true
  this.EmpWithHoldCertify=true
  this.MinnsottaWithHold=true;


 }
    let param = new URLSearchParams();
  
      param.append("DocumentId",this.emitemployeeBO.agreementId);
      param.append("EmployeeId", this.emitemployeeBO.employeeid);
    
  this.getclientDetails();
  this.GetEmployeePayrateList();
  this.agreementService.getEmpDocumentList(param).pipe(takeUntil(this.onDestroy$)).subscribe((datas:any) => {

     let data = JSON.parse(datas);
  
     this.backgroundBo = data.empDocuments.backgroundStudyAuthorization;

     this.backgroundBo.genderLid = data.empProfile.gender_Name;
     this.backgroundBo.state = data.empProfile.steet;
     this.backgroundBo.address = data.empProfile.street;
     this.backgroundBo.zip = data.empProfile.zipcode;
     this.payNoticeBo.employeeName = data.empProfile.name;
     this.employeeAgreementBo = data.empDocuments.employeeAgreementAndDirectDeposit;
     this.employeeApplicationBo = data.empDocuments.employeeApplicationCover;
     this.employeesWithholdingBo = data.empDocuments.employeesWithholdingCertificate;
     this.employeesWithholdingBo.maritialStatus = data.empDocuments.employeesWithholdingCertificate.maritialStatus;

  
     
     this.employmentEligibilityBo = data.empDocuments.employmentEligibilityVerification;
   
     this.individualDirectSupportBo = data.empDocuments.individualDirectSupportWorkerEnrollmentApplication;
     this.payNoticeBo = data.empDocuments.payNotice;
     this.relationshipBo = data.empDocuments.relationshipDisclosure;
     this.w4MinnesotaWithholdingBo = data.empDocuments.w4MinnesotaWithholdingAllowanceOrExemptionCertificate;
     this.w4MNInstructionsBo = data.empDocuments.w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipients;
     this.reationshipname= this.relationshipBo.relationshipName;
     this.individualSupportWorkerBo = data.empDocuments.individualSupportWorkerProviderAgreement;
     if(this.DSwstudyBolist.length == 0) {
      this.DSwstudyBolist = [
      {
      bsgNumber: null,
      applicationNumber: null,
      facilityId: null,
      }

      ]
     }
      this.DSwstudyBolist = data.empDocuments.individualDirectSupportWorkerEnrollmentApplication.dswBackgroundStudyInfoForms;
      this.w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2 = data.empDocuments.w4MinnesotaWithholdingAllowanceOrExemptionCertificate.exemption_minnesota_withholdingsec2;

      


        this.individualSupportWorkerBo.signDeclaration = data.empDocuments.individualSupportWorkerProviderAgreement.signDeclaration;
        this.individualSupportWorkerBo.directSupportWorkerInitial = data.empDocuments.individualSupportWorkerProviderAgreement.directSupportWorkerInitial;

     this.individualDirectSupportBoRadio1=JSON.stringify(this.individualDirectSupportBo.isMcoClaimsOnly)
      this.individualDirectSupportBoRadio2=JSON.stringify(this.individualDirectSupportBo.isQualifiedEnhancedRateTraining)
      this.individualDirectSupportBoRadio3=JSON.stringify(this.individualDirectSupportBo.isAffiliateIndividualDsw);
      this.individualDirectSupportBo.newHireOrReHire = data.empDocuments.individualDirectSupportWorkerEnrollmentApplication.newHireOrReHire;

      
      this.spouse =JSON.stringify(this.relationshipBo.employerandWantWorkers)
     this.backgroundBo.dob =
     this.backgroundBo.dob != null &&
     this.backgroundBo.dob != undefined &&
     this.backgroundBo.dob != ""
       ? this.datepipe.transform(this.backgroundBo.dob, "MM/dd/yyyy")
       : null;
   this.backgroundBo.previousNamesUsedDate1 =
     this.backgroundBo.previousNamesUsedDate1 != null &&
     this.backgroundBo.previousNamesUsedDate1 != undefined &&
     this.backgroundBo.previousNamesUsedDate1 != ""
       ? this.datepipe.transform(
           this.backgroundBo.previousNamesUsedDate1,
           "MM/dd/yyyy"
         )
       : null;
   this.backgroundBo.previousNamesUsedDate2 =
     this.backgroundBo.previousNamesUsedDate2 != null &&
     this.backgroundBo.previousNamesUsedDate2 != undefined &&
     this.backgroundBo.previousNamesUsedDate2 != ""
       ? this.datepipe.transform(
           this.backgroundBo.previousNamesUsedDate2,
           "MM/dd/yyyy"
         )
       : null;
   this.backgroundBo.previous_Addresses_UsedDate1 =
     this.backgroundBo.previous_Addresses_UsedDate1 != null &&
     this.backgroundBo.previous_Addresses_UsedDate1 != undefined &&
     this.backgroundBo.previous_Addresses_UsedDate1 != ""
       ? this.datepipe.transform(
           this.backgroundBo.previous_Addresses_UsedDate1,
           "MM/dd/yyyy"
         )
       : null;
   this.backgroundBo.previous_Addresses_UsedDate2 =
     this.backgroundBo.previous_Addresses_UsedDate2 != null &&
     this.backgroundBo.previous_Addresses_UsedDate2 != undefined &&
     this.backgroundBo.previous_Addresses_UsedDate2 != ""
       ? this.datepipe.transform(
           this.backgroundBo.previous_Addresses_UsedDate2,
           "MM/dd/yyyy"
         )
       : null;
   this.backgroundBo.previous_Addresses_UsedDate3 =
     this.backgroundBo.previous_Addresses_UsedDate3 != null &&
     this.backgroundBo.previous_Addresses_UsedDate3 != undefined &&
     this.backgroundBo.previous_Addresses_UsedDate3 != ""
       ? this.datepipe.transform(
           this.backgroundBo.previous_Addresses_UsedDate3,
           "MM/dd/yyyy"
         )
       : null;

   this.backgroundBo.applicantSignatureDate =
     this.backgroundBo.applicantSignatureDate != null &&
     this.backgroundBo.applicantSignatureDate != null &&
     this.backgroundBo.applicantSignatureDate != ""
       ? this.datepipe.transform(
           this.backgroundBo.applicantSignatureDate,
           "MM/dd/yyyy"
         )
       : null;
   this.backgroundBo.parentSignatureDate =
     this.backgroundBo.parentSignatureDate != null &&
     this.backgroundBo.parentSignatureDate != undefined &&
     this.backgroundBo.parentSignatureDate != ""
       ? this.datepipe.transform(
           this.backgroundBo.parentSignatureDate,
           "MM/dd/yyyy"
         )
       : null;
   this.payNoticeBo.employeeSignDate =
     this.payNoticeBo.employeeSignDate != null &&
     this.payNoticeBo.employeeSignDate != undefined &&
     this.payNoticeBo.employeeSignDate != ""
       ? this.datepipe.transform(
           this.payNoticeBo.employeeSignDate,
           "MM/dd/yyyy"
         )
       : null;
   this.payNoticeBo.employerSignDate =
     this.payNoticeBo.employerSignDate != null &&
     this.payNoticeBo.employerSignDate != undefined &&
     this.payNoticeBo.employerSignDate != ""
       ? this.datepipe.transform(
           this.payNoticeBo.employerSignDate,
           "MM/dd/yyyy"
         )
       : null;

   this.relationshipBo.dob =
     this.relationshipBo.dob != null &&
     this.relationshipBo.dob != undefined &&
     this.relationshipBo.dob != ""
       ? this.datepipe.transform(this.relationshipBo.dob, "MM/dd/yyyy")
       : null;
   this.relationshipBo.applicantSignDate =
     this.relationshipBo.applicantSignDate != null &&
     this.relationshipBo.applicantSignDate != undefined &&
     this.relationshipBo.applicantSignDate != ""
       ? this.datepipe.transform(
           this.relationshipBo.applicantSignDate,
           "MM/dd/yyyy"
         )
       : null;
   this.relationshipBo.employersSignDate =
     this.relationshipBo.employersSignDate != null &&
     this.relationshipBo.employersSignDate != undefined &&
     this.relationshipBo.employersSignDate != ""
       ? this.datepipe.transform(
           this.relationshipBo.employersSignDate,
           "MM/dd/yyyy"
         )
       : null;

   this.individualDirectSupportBo.previousEmployementEndDate =
     this.individualDirectSupportBo.previousEmployementEndDate != null &&
     this.individualDirectSupportBo.previousEmployementEndDate !=
       undefined &&
     this.individualDirectSupportBo.previousEmployementEndDate != ""
       ? this.datepipe.transform(
           this.individualDirectSupportBo.previousEmployementEndDate,
           "MM/dd/yyyy"
         )
       : null;
   this.individualDirectSupportBo.dob =
     this.individualDirectSupportBo.dob != null &&
     this.individualDirectSupportBo.dob != undefined &&
     this.individualDirectSupportBo.dob != ""
       ? this.datepipe.transform(
           this.individualDirectSupportBo.dob,
           "MM/dd/yyyy"
         )
       : null;

   this.individualDirectSupportBo.optionalTrainingCompletionDate =
     this.individualDirectSupportBo.optionalTrainingCompletionDate !=
       null &&
     this.individualDirectSupportBo.optionalTrainingCompletionDate !=
       undefined &&
     this.individualDirectSupportBo.optionalTrainingCompletionDate != ""
       ? this.datepipe.transform(
           this.individualDirectSupportBo.optionalTrainingCompletionDate,
           "MM/dd/yyyy"
         )
       : null;
   this.individualDirectSupportBo.optionalTrainingExpirationDate =
     this.individualDirectSupportBo.optionalTrainingExpirationDate !=
       null &&
     this.individualDirectSupportBo.optionalTrainingExpirationDate != "" &&
     this.individualDirectSupportBo.optionalTrainingExpirationDate !=
       undefined
       ? this.datepipe.transform(
           this.individualDirectSupportBo.optionalTrainingExpirationDate,
           "MM/dd/yyyy"
         )
       : null;
   this.employmentEligibilityBo.dob =
     this.employmentEligibilityBo.dob != null &&
     this.employmentEligibilityBo.dob != undefined &&
     this.employmentEligibilityBo.dob != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.dob,
           "MM/dd/yyyy"
         )
       : null;
   this.employmentEligibilityBo.alien_Registration_ExpiryDate =
     this.employmentEligibilityBo.alien_Registration_ExpiryDate != null &&
     this.employmentEligibilityBo.alien_Registration_ExpiryDate !=
       undefined &&
     this.employmentEligibilityBo.alien_Registration_ExpiryDate != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.alien_Registration_ExpiryDate,
           "MM/dd/yyyy"
         )
       : null;

   this.employmentEligibilityBo.todaysDate =
     this.employmentEligibilityBo.todaysDate != null &&
     this.employmentEligibilityBo.todaysDate != undefined &&
     this.employmentEligibilityBo.todaysDate != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.todaysDate,
           "MM/dd/yyyy"
         )
       : null;

   this.employmentEligibilityBo.signOfPreparerorTraslatorDate =
     this.employmentEligibilityBo.signOfPreparerorTraslatorDate != null &&
     this.employmentEligibilityBo.signOfPreparerorTraslatorDate !=
       undefined &&
     this.employmentEligibilityBo.signOfPreparerorTraslatorDate != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.signOfPreparerorTraslatorDate,
           "MM/dd/yyyy"
         )
       : null;

   this.employmentEligibilityBo.expirationDate =
     this.employmentEligibilityBo.expirationDate != null &&
     this.employmentEligibilityBo.expirationDate != undefined &&
     this.employmentEligibilityBo.expirationDate != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.expirationDate,
           "MM/dd/yyyy"
         )
       : null;

   this.employmentEligibilityBo.expirationDate1 =
     this.employmentEligibilityBo.expirationDate1 != null &&
     this.employmentEligibilityBo.expirationDate1 != undefined &&
     this.employmentEligibilityBo.expirationDate1 != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.expirationDate1,
           "MM/dd/yyyy"
         )
       : null;
   this.employmentEligibilityBo.expirationDate2 =
     this.employmentEligibilityBo.expirationDate2 != null &&
     this.employmentEligibilityBo.expirationDate2 != undefined &&
     this.employmentEligibilityBo.expirationDate2 != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.expirationDate2,
           "MM/dd/yyyy"
         )
       : null;
   this.employmentEligibilityBo.expirationDate3 =
     this.employmentEligibilityBo.expirationDate3 != null &&
     this.employmentEligibilityBo.expirationDate3 != undefined &&
     this.employmentEligibilityBo.expirationDate3 != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.expirationDate3,
           "MM/dd/yyyy"
         )
       : null;
   this.employmentEligibilityBo.expirationDate4 =
     this.employmentEligibilityBo.expirationDate4 != null &&
     this.employmentEligibilityBo.expirationDate4 != undefined &&
     this.employmentEligibilityBo.expirationDate4 != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.expirationDate4,
           "MM/dd/yyyy"
         )
       : null;

   this.employmentEligibilityBo.employeesFirstdayEmployment =
     this.employmentEligibilityBo.employeesFirstdayEmployment != null &&
     this.employmentEligibilityBo.employeesFirstdayEmployment !=
       undefined &&
     this.employmentEligibilityBo.employeesFirstdayEmployment != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.employeesFirstdayEmployment,
           "MM/dd/yyyy"
         )
       : null;

   this.employmentEligibilityBo.employerSignDate1 =
     this.employmentEligibilityBo.employerSignDate1 != null &&
     this.employmentEligibilityBo.employerSignDate1 != undefined &&
     this.employmentEligibilityBo.employerSignDate1 != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.employerSignDate1,
           "MM/dd/yyyy"
         )
       : null;

   this.employmentEligibilityBo.reverificationDate =
     this.employmentEligibilityBo.reverificationDate != null &&
     this.employmentEligibilityBo.reverificationDate != undefined &&
     this.employmentEligibilityBo.reverificationDate != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.reverificationDate,
           "MM/dd/yyyy"
         )
       : null;

   this.employmentEligibilityBo.documentExpiryDate =
     this.employmentEligibilityBo.documentExpiryDate != null &&
     this.employmentEligibilityBo.documentExpiryDate != undefined &&
     this.employmentEligibilityBo.documentExpiryDate != ""
       ? this.datepipe.transform(
           this.employmentEligibilityBo.documentExpiryDate,
           "MM/dd/yyyy"
         )
       : null;
   this.individualSupportWorkerBo.signDate =
     this.individualSupportWorkerBo.signDate != null &&
     this.individualSupportWorkerBo.signDate != undefined &&
     this.individualSupportWorkerBo.signDate != ""
       ? this.datepipe.transform(
           this.individualSupportWorkerBo.signDate,
           "Mm/dd/yyyy"
         )
       : null;

    this.individualDirectSupportBo.signDate =(
      this.individualDirectSupportBo.signDate != null &&
      this.individualDirectSupportBo.signDate != undefined &&
      this.individualDirectSupportBo.signDate != "")
        ? this.datepipe.transform(
            this.individualDirectSupportBo.signDate, "MM/dd/yyyy" )

        : null;

   this.employeesWithholdingBo.signDate =
     this.employeesWithholdingBo.signDate != null &&
     this.employeesWithholdingBo.signDate != undefined &&
     this.employeesWithholdingBo.signDate != ""
       ? this.datepipe.transform(
           this.employeesWithholdingBo.signDate,
           "MM/dd/yyyy"
         )
       : null;

   this.employeesWithholdingBo.firstDateOfEmployeement =
     this.employeesWithholdingBo.firstDateOfEmployeement != null &&
     this.employeesWithholdingBo.firstDateOfEmployeement != undefined &&
     this.employeesWithholdingBo.firstDateOfEmployeement != ""
       ? this.datepipe.transform(
           this.employeesWithholdingBo.firstDateOfEmployeement,
           "MM/dd/yyyy"
         )
       : null;

   this.w4MinnesotaWithholdingBo.date =
     this.w4MinnesotaWithholdingBo.date != null &&
     this.w4MinnesotaWithholdingBo.date != undefined &&
     this.w4MinnesotaWithholdingBo.date != ""
       ? this.datepipe.transform(
           this.w4MinnesotaWithholdingBo.date,
           "MM/dd/yyyy"
         )
       : null;
       this.appsign1 = this.backgroundBo.applicantSignature;
       this.sign4 = this.backgroundBo.parentSignature;

       this.Gurdsign3 = this.payNoticeBo.employeeSign;
       this.employeesign2 = this.payNoticeBo.employerSign;

       this.clientsign0 = this.relationshipBo.employersSign;
       this.employeesign3 = this.relationshipBo.applicantSign;
       this.clientsign2 = this.employeeAgreementBo.employee_sign;

       this.individualsign = this.individualDirectSupportBo.sign;

       this.repsign = this.individualSupportWorkerBo.sign;

       this.repsign = this.individualSupportWorkerBo.sign;

      this.employeesign = this.employmentEligibilityBo.signOfEmployee;
      this.translatorsign = this.employmentEligibilityBo.employerSign;
      this.authorizedsign = this.employmentEligibilityBo.employerSign1;
      this.authorizedrepsign =
        this.employmentEligibilityBo.signOfPreparerorTraslator;


       this.Gurdsign = this.employeesWithholdingBo.employeeSignature;
       this.clientsign1 = this.w4MinnesotaWithholdingBo.signature;
        
       
   
       this.prepopulatefun();
       this.prepopulateclientfun();
       this.getEmployerType();
     
       setTimeout(() => {
        this.empDocumentDownload();
       } ,100)
       
       
     
        

  },
  (err: any) => {
    if (err) {
      this.toastrService.error(err, "Error"), 8000;
    }
  }
  )
}

passerror:boolean;
admin_Password:any;
filedname:any;
passvalid(event) {
  let str = event.target.value;
  if (str.match(/[a-z]/g) && str.match(
    /[A-Z]/g) && str.match(
      /[0-9]/g) && str.match(
        /[^a-zA-Z\d]/g) && str.length >= 8) {
    this.passerror = false;
  }
  else {
    this.passerror = true;
  }
}
AccountNumberShowBO:AccountNumberShowBO = new AccountNumberShowBO()
setfieldName(val) {
  this.admin_Password = null;
  const passControl = this.showPassAccountRouting.get('Password');
  if (passControl) {
    passControl.markAsPristine();
    passControl.markAsUntouched(); 
  }  
  this.filedname=val;
  this.showedString='';
  this.AccountNumberShowBO=new AccountNumberShowBO();
}
showedString:string;
showRoutingAcct() {
  this.AccountNumberShowBO.employeeId=this.emitemployeeBO.employeeid;
  this.AccountNumberShowBO.fieldname=this.filedname;
  this.AccountNumberShowBO.admin_Password=this.admin_Password;
 this.AccountNumberShowBO.tableType="payroll";
  this.EmployeePayrollService.ShowEmployeePayrolldata(this.AccountNumberShowBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
 
   
    this.passerror = false;
   if(data) {
    if(this.filedname == 'Bank Routing') {
      this.employeeAgreementBo.routing=data;
       this.bankRoutePassword = 'text';
    } else if(this.filedname == 'Account Number') {
      this.employeeAgreementBo.account=data;
      this.Password='text';
    }
    document.getElementById("openShowPass").click();
    //this.showedString=data;

   }
    // this.toasterservice.success(
    //   'EvvTimesheet deleted successfully!'
    // ), 8000;     
  //  document.getElementById("openShowPass").click();
   
   
  },
    (err: HttpErrorResponse) => {
      this.passerror = false;
      this.toastrService.error(
        err.error
      ), 4000;
     
    }
  );
}

  submitAggrementDetails() {
    console.log("this.agreementBo",this.agreementBo);
    let submitAggremntNo:SubmitEmployeeAggremntBo = new SubmitEmployeeAggremntBo();
   submitAggremntNo.aggrementId=this.emitemployeeBO.agreementId;
   submitAggremntNo.employeeStatusLid=this.emitemployeeBO.statusLid;
   let getlogin= localStorage.getItem("onboardLoginUser");
   if(getlogin=="EMPLOYEE") {
     submitAggremntNo.type="Employee";
     this.emitemployeeBO.employeestatus = 'Submitted'
   } else if(getlogin == "CLIENT") {
    submitAggremntNo.type="Client";
    this.emitemployeeBO.employerstatus ='Submitted'
   }
    this.agreementService
        .submitEmployeeDocPortal(submitAggremntNo)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            if(getlogin=="EMPLOYEE") {             
              this.emitemployeeBO.employeestatus = 'Submitted'
            } else if(getlogin == "CLIENT") {            
             this.emitemployeeBO.employerstatus ='Submitted'
            }
            this.toastrService.success("Employee Agreement Submitted Successfully");
           // this.getAgreementDetails();
           this.DataToClientOnBoardList();
          },
          (err: HttpErrorResponse) => {
            this.toastrService.error(err.error, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
  }


  show_pass:boolean=false;
  Password:string='password';
  showPass() {
    // this.show_pass = !this.show_pass;
  
    console.log(this.tempAccNo,"this.tempAccNo");
    console.log(this.employeeAgreementBo.account,"this.employeePayrollinformationBO.accountNumber")
   console.log(this.show_pass,"this.show_bankrout------");    
    if(this.tempAccNo == this.employeeAgreementBo.account && this.show_pass) {
      console.log("If")
      this.setfieldName('Account Number');
      document.getElementById('openShowPass').click();
    } else {
      console.log("else")
      return (this.show_pass ? this.Password = 'text' : this.Password = 'password');
    }
    // this.show_pass = !this.show_pass;
  }
  show_bankrout:boolean=false;
  bankRoutePassword:string='password';
  tempRouting:string;
  tempAccNo:string;
  show_bankroutfun() {
    // this.show_bankrout = !this.show_bankrout;
   
   // console.log(val,"bankRountingPayroll");
   console.log(this.tempRouting,'this.tempRouting');
   console.log(this.employeeAgreementBo.routing,'this.employeePayrollinformationBO.bankRounting');
   console.log(this.show_bankrout,"this.show_bankrout------");
    if(this.tempRouting == this.employeeAgreementBo.routing && this.show_bankrout) {
      console.log("If");
      this.setfieldName('Bank Routing');
      document.getElementById('openShowPass').click();     
    } else {
      console.log("else");
      return (this.show_bankrout ? this.bankRoutePassword = 'text' : this.bankRoutePassword = 'password');
    }
  }

  closeeyeicon() {
    if(this.filedname == 'Bank Routing') {
       this.show_bankrout=false;
    } else if(this.filedname =='Account Number') {
        this.show_pass=false;
    }
  }

  
  DataToClientOnBoardList() {
    let emitBo = new PageNavigateBo();
    emitBo.close = true;
    this.newItemEvent.emit(emitBo);
  }
}

